import { LocaleMessageObject } from 'vue-i18n';

const es: LocaleMessageObject = {
    message: {
        one: "El test message"
    },
    shared: {
        button: {
            add: "Añadir",
            "add-new": "Añadir nuevo",
            cancel: "Cancelar",
            close: "Cerrar",
            save: "Guardar",
            archive: "Archivar",
            create: "Crear",
            delete: "Eliminar",
            edit: "Editar",
            export: "Exportar",
            import: "Importar",
            restore: "Restaurar",
            upload: "Subir",
            "upload-file": "Subir archivo",
            update: "Actualizar",
            next: "Siguiente",
            back: "Atrás",
            done: "Hecho",
            complete: "Completar",
            "abandon-changes": "Descartar cambios",
            "download-template": "Descargar plantilla"
        },
        label: {
            crew: "Personal de turno",
            filter: "Filtro",
            from: "desde",
            leave: "Ausencia",
            "major-service": "Servicio mayor",
            "minor-service": "Servicio menor",
            name: "Nombre",
            overtime: "Horas extra",
            role: "Función",
            service: "Servicio",
            unserviceable: "Inservible",
            "weekly-service": "Servicio semanal",
            action: "Acción",
            comments: "Comentarios",
            description: "Descripción",
            "not-saved": "No guardado"
        },
        message: {
            "no-connection": "Sin conexión",
            "shift-planning-not-started": "La planificación de este turno no ha comenzado",
            "week-planning-not-started": "La planificación de esta semana no ha comenzado",
            "select-a": "Seleccionar un {term}",
            "error-saving": "Se produjo un error al guardar"
        },
        concept: {
            shift: "Turno",
            cycle: "Ciclo",
            task: "Tarea"
        },
        heading: {
            "add-term": "Agregar {term}",
            "create-term": "Crear {term}",
            "create-term-2": "Crear {term2} de {term1}",
            "edit-term": "Editar {term}",
            "select-term": "Seleccionar {term}",
            "term-details": "Detalles de {term}",
            "update-term-status": "Actualizar estado de {term}",
            "update-term-status-detail": "Actualizar estado de {term} - {detail}",
            "update-term-2": "Actualizar {term1} - {term2}",
            "availability-for": "Disponibilidad para {name}"
        },
        validation: {
            "must-not-match-existing-name": "No debe coincidir con un nombre existente.",
            "must-not-match-existing-code": "No debe coincidir con un código existente.",
            "must-not-match-existing-short-name": "No debe coincidir con un nombre corto existente.",
            "must-be-unique": "Debe ser único",
            "maximum-1-decimal-point": "Máximo 1 decimal",
            "not-negative": "No negativo"
        }
    },
    equipment: {
        "archived-term": "{term} archivado",
        "mark-as-serviceable": "Marcar como utilizable",
        "mark-as-unserviceable": "Marcar como inservible",
        "show-conflicts": "Mostrar conflictos"
    },
    "equipment-availability-dialog": {
        heading: "Disponibilidad del equipo"
    },
    actuals: {
        "error-saving-please-try-again": "Se produjo un error al guardar: {errors}. Inténtelo de nuevo.",
        "end-date": "Fecha de fin",
        "export-data-by-date-range": "Exportar datos por rango de fechas",
        "export-data-for-current-shift-not-implemented": "Exportar datos del turno actual (no implementado)",
        "start-date": "Fecha de inicio",
        "plod-entry": "Entrada de PLOD",
        "key-physicals": "Físicos clave",
        inspections: "Inspecciones",
        download: "Descargar",
        "read-only": "Solo lectura",
        editing: "Editando",
        "clear-data": "Borrar datos",
        "export-to-csv": "Exportar a CSV",
        "enter-edit-mode": "Entrar en modo de edición",
        "save-and-exit": "Guardar y salir",
        "actuals-entry": "Entrada de valores reales",
        "confirm-clear-data": "¿Está seguro de que desea borrar todos los datos de valores reales de este turno? Esto eliminará permanentemente todos los datos de Entrada de PLOD, Físicos clave e Inactividad del equipo.",
        "this-action-cannot-be-undone": "Esta acción no se puede deshacer.",
        "successfully-cleared-data": "Se borraron correctamente todos los datos del turno.",
        "error-clearing-data": "Error al borrar los datos del turno."
    },
    "actuals-definition-groups": {
        "assigned-actuals-definitions": "Definiciones de valores reales asignadas",
        "actuals-definition-groups": "Grupos de definiciones de valores reales",
        "archived-groups": "Grupos archivados",
        "actuals-definitions-sort-order": "Orden de clasificación de las definiciones de valores reales",
        "assigned-task-types": "Tipos de tarea asignados",
        "group-in-use-cannot-alter-or-delete": "Este grupo está en uso y su nombre no se puede modificar ni se puede eliminar.",
        "group-name": "Nombre del grupo",
        "assigned-definitions": "Definiciones asignadas",
        "assigned-tasks": "Tareas asignadas",
        "restore-group-definitions-warning": "Este grupo contiene definiciones que están asignadas a otros grupos y se eliminarán de este grupo si se restaura.",
        "the-definitions-are": "Las definiciones son: ",
        "do-you-want-to-continue": "¿Desea continuar?"
    },
    "actuals-definitions": {
        "custom-value-set": "Conjunto de valores personalizado",
        "decimal-places": "Decimales",
        "field-type": "Tipo de campo",
        formula: "Fórmula",
        metric: "Métrica",
        summable: "Sumable",
        "value-set": "Conjunto de valores",
        "actuals-definitions": "Definiciones de valores reales",
        "formula-hint": "Ej. [Longitud de perforación] * [Cantidad] + 15",
        "custom-value-set-hint": "Lista de valores delimitada por barras verticales (ej. OpciónA|OpciónB|OpciónC)",
        "value-set-data-type-mismatch": "El conjunto de valores debe coincidir con el tipo de dato seleccionado",
        "archived-definitions": "Definiciones archivadas",
        "assigned-definition-groups": "Grupos de definiciones asignados",
        "production-rate-type": "Tipo de tasa de producción",
        "only-numeric-types-may-target-a-production-rate": "Solo los tipos numéricos pueden apuntar a una tasa de producción",
        "pick-a-driving-production-class": "Elija una clase de producción impulsora: Perforación, Carga o Extracción (Remota y Convencional).",
        "definition-assigned-to-mismatched-tasks": "Esta definición está asignada a tareas (a través de los Grupos de definiciones asignados) que no coinciden con el tipo de tasa de producción seleccionado. Asegúrese de estar conforme con esta selección.",
        "definition-in-use-cannot-alter": "Esta definición está en uso y no se puede modificar ni eliminar. Aún puede archivarse o restaurarse.",
        "definition-name": "Nombre de la definición",
        "assigned-groups": "Grupos asignados",
        "weight-t": "Peso (t)",
        "weight-kg": "Peso (kg)"
    },
    "ad-hoc-task-editor": {
        "remove-name": "Eliminar {name}",
        "overridden-location-name": "Nombre de ubicación sustituido",
        "task-category": "Categoría de tarea",
        "task-type": "Tipo de tarea",
        "override-task-name": "Sustituir nombre de la tarea",
        "start-at": "Comenzar a las",
        "duration-minutes": "Duración (minutos)",
        "effort-minutes": "Esfuerzo (minutos)",
        priority: "Prioridad",
        consumables: "Consumibles",
        "start-chainage-m": "Cadenamiento inicial (m)",
        "end-chainage-m": "Cadenamiento final (m)",
        "edit-task": "Editar tarea",
        "add-task": "Añadir tarea"
    },
    "add-cycles": {
        "remove-name": "Eliminar {name}",
        "cycle-type": "Tipo de ciclo",
        select: "Seleccionar",
        "cycle-has-no-tasks": "El ciclo no tiene tareas",
        "target-term": "{term} objetivo",
        "add-before": "Añadir antes",
        "add-cycle": "Añadir ciclo",
        warning: "¡Advertencia!",
        "inserting-cycles-warning": "Insertar ciclos en el plan puede provocar que los ciclos posteriores se desplacen"
    },
    "add-cycles-from-shift-dialog": {
        "start-at": "Comenzar a las",
        "add-cycle": "Añadir ciclo",
        "cycle-type": "Tipo de ciclo",
        "cycle-has-no-tasks": "El ciclo no tiene tareas",
        "must-provide-cycle-start-time": "Debe proporcionar una hora de inicio del ciclo.",
        "cycle-start-time-must-fall-within-shift": "La hora de inicio del ciclo debe estar dentro del turno."
    },
    "add-location": {
        search: "Buscar",
        "select-all": "Seleccionar todo",
        select: "Seleccionar"
    },
    "add-task-dialog": {
        "ring-is-already-status": "El anillo ya está {status}",
        "ring-is-status-would-skip": "El anillo está {status}. Esto omitiría {skipped}",
        "ring-not-reached-target": "El anillo aún no ha alcanzado el objetivo para {status}.",
        "ring-already-completed-target": "El anillo ya ha completado la cantidad objetivo para {status}.",
        "duration-minutes": "Duración (minutos)",
        quantity: "Cantidad",
        "rate-calculated": "Tasa (calculada)",
        "start-at": "Comenzar a las",
        standard: "Estándar",
        rings: "Anillos",
        "add-task": "Añadir tarea",
        "fire-duration-cannot-be-changed": "La duración de la voladura no se puede cambiar.",
        "task-type": "Tipo de tarea",
        "term-task": "Tarea de {term}",
        "manually-add-task": "Añadir tarea manualmente",
        "add-task-before": "Añadir tarea antes...",
        "add-task-after": "Añadir tarea después...",
        "must-provide-starting-time-for-task": "Debe proporcionar una hora de inicio para la tarea.",
        "task-start-time-must-fall-within-shift": "La hora de inicio de la tarea debe estar dentro del turno.",
        "not-all-rings-are-charged": "No todos los anillos están cargados.",
        "not-all-rings-have-completed-charging": "No todos los anillos han completado la carga.",
        "blast-packet-already-fired": "El paquete de voladura ya ha sido disparado.",
        "blast-packet-already-started-bogging": "El paquete de voladura ya ha comenzado la extracción.",
        "blast-packet-not-yet-fired": "El paquete de voladura aún no ha sido disparado.",
        "bogging-marked-complete": "La extracción del paquete de voladura se ha marcado como completada.",
        "blast-packet-already-completed-bogging-quantity": "El paquete de voladura ya ha completado la cantidad objetivo de extracción."
    },
    "assign-shift-owner": {
        "i-confirm-that-i-have-permission-to-take": "Confirmo que tengo permiso para asumir la propiedad del turno.",
        "select-user": "Seleccionar usuario",
        "handover-meeting-not-complete": "La reunión de entrega no está completa",
        "open-handover-meeting": "Abrir reunión de entrega",
        "shift-planner": "Planificador de turno",
        "confirm-handover-meeting-not-complete": "Confirmo que la reunión de entrega no está completa.",
        "confirm-user-no-shift-planner-role": "Confirmo que el usuario seleccionado no tiene la función de Planificador de turno."
    },
    "audit-event-explorer": {
        "date-range": "Rango de fechas",
        "event-type": "Tipo de evento",
        "from-date": "Fecha desde",
        namespace: "Espacio de nombres",
        "to-date": "Fecha hasta",
        advanced: "Avanzado",
        "last-7-days": "Últimos 7 días",
        "last-30-days": "Últimos 30 días",
        "last-90-days": "Últimos 90 días"
    },
    "blast-packet-ring-changes-dialog": {
        "duration-minutes": "Duración (minutos)",
        minutes: "Minutos",
        "proceed-without-updating": "Continuar sin actualizar",
        "changed-drill-length-from": "Se cambió la longitud de perforación de",
        "changed-charge-amount-from": "Se cambió la cantidad de carga de",
        "changed-extraction-amount-from": "Se cambió la cantidad de extracción de",
        "no-additional-levels": "No hay niveles adicionales, agregue algunos a continuación"
    },
    board: {
        "shift-date": "Turno {date}",
        "add-name": "Agregar {name}",
        "some-locations-visible-even-if-filtered": "Algunas {term} pueden ser visibles incluso si están filtradas, debido a que contienen tareas dependientes",
        "you-are-currently-assigning": "Actualmente está asignando {equipment}",
        "row-task-update-for": "Actualización de tarea de fila para {taskId}",
        "add-cycle": "Añadir ciclo",
        "eos-status": "ESTADO EOS",
        "sos-status": "ESTADO SOS",
        "shift-board": "Tablero de turno",
        "exit-by-pressing-ctrl-y-this-mode-disables-certain-constraints-on-board-tasks-use-with-caution": "Salga presionando \"CTRL+Y\". Este modo desactiva ciertas restricciones en las tareas del tablero. ÚSELO CON PRECAUCIÓN.",
        "add-manual-task": "Añadir tarea manual",
        "choose-action": "Elegir acción",
        "editing-actuals": "Actualmente está editando los valores reales.",
        "highlighting-unresourced-tasks": "Resaltando tareas sin recursos",
        "location-utilisation": "Utilización de ubicaciones",
        "utilisation-priority-1": "Porcentaje de utilización de las ubicaciones de prioridad 1 en este turno",
        "utilisation-priority-2": "Porcentaje de utilización de las ubicaciones de prioridad 2 en este turno",
        "utilisation-lower-priority": "Porcentaje de utilización de las ubicaciones de menor prioridad en este turno",
        "plan-manual-cycle": "¿Planificar ciclo manual?",
        "manual-cycle-warning-1": "Ordo ha sido diseñado para desarrollar un plan de turno a partir de un plan semanal preexistente.",
        "manual-cycle-warning-2": "La necesidad de añadir un ciclo manual indica que no se ha desarrollado un plan semanal.",
        "manual-cycle-warning-3": "Se prefiere añadir ciclos en el tablero semanal.",
        "manual-cycle": "Ciclo manual",
        "promoting-fire-task-to-stope": "Promoviendo tarea de voladura a rebaje.",
        "could-not-find-did-not-fire-task-type": "No se pudo encontrar el tipo de tarea de no disparo",
        "filtering-locations-warning": "Está filtrando ubicaciones sin actividad y es posible que no vea la nueva ubicación.",
        "actuals-saved": "Valores reales guardados",
        "update-task-error-reloading": "Se produjo un error inesperado al actualizar la tarea. Recargando los detalles del turno desde el servidor.",
        "update-task-error-baseline": "Se produjo un error inesperado al actualizar la tarea. Todos los cambios realizados sin conexión se guardarán como línea base.",
        "update-task-error": "Se produjo un error inesperado al actualizar la tarea",
        unavailable: "No disponible",
        "manage-conflict": "Gestionar conflicto"
    },
    "child-location-editor": {
        "display-order": "Orden de visualización",
        "is-drawpoint": "Es punto de extracción",
        level: "Nivel",
        "must-not-match-existing-display-order-in-stope": "No debe coincidir con un orden de visualización existente en el rebaje.",
        "location-must-be-in-format": "La ubicación debe tener el formato '{format}'"
    },
    "communications-configuration": {
        "must-be-or-less-characters": "Debe tener {num} caracteres o menos",
        department: "Departamento",
        description: "Descripción",
        "icon-colour": "Color del icono",
        type: "Tipo",
        "week-or-shift": "¿Semana o turno?",
        "communications-configuration": "Configuración de comunicaciones",
        "comms-field": "Campo de comunicaciones",
        "weekly-comms-fields": "Campos de comunicaciones semanales",
        "shift-comms-fields": "Campos de comunicaciones del turno",
        "archived-comms-fields": "Campos de comunicaciones archivados",
        persistence: "Persistencia",
        order: "Orden",
        "fields-reordered": "Campos reordenados"
    },
    "connect-devices": {
        department: "Departamento",
        "generate-registration-code-now": "Generar código de registro ahora",
        code: "Código",
        "code-expires": "El código caduca",
        "code-refreshed": "Código actualizado",
        "copied-to-clipboard": "Copiado al portapapeles",
        "failed-to-copy": "No se pudo copiar"
    },
    "create-blast-packet-dialog-v2": {
        cycle: "Ciclo",
        "duration-minutes": "Duración (minutos)",
        minutes: "Minutos",
        ring: "Anillo",
        stope: "Cámara",
        "enter-blast-packet-design-details": "Ingrese los detalles de diseño del paquete de voladura",
        "create-term-dialog": "Crear cuadro de diálogo de {term}",
        "cycles-must-contain-drill-charge": "Los ciclos deben contener tareas de perforación y carga, y ninguna tarea de voladura o extracción.",
        "add-term": "Añadir {term}",
        "no-additional-levels": "No hay {term} adicionales, añada algunos abajo",
        "term-fire-task": "Tarea de voladura de {term}",
        "term-bog-task": "Tarea de extracción de {term}",
        "tolerance-percent": "Tolerancia (%)",
        "at-least-one-term-must-be-added": "Se debe añadir al menos un {term}."
    },
    "create-user-dialog": {
        email: "Correo electrónico",
        "initial-password": "Contraseña inicial",
        roles: "Funciones",
        select: "Seleccionar {term}",
        "add-user": "Añadir usuario"
    },
    crews: {
        "select-departments": "Seleccionar departamentos",
        "cannot-import-no-staff-roles-available": "No se puede importar: no hay funciones de personal disponibles.",
        roles: "Funciones",
        count: "Cantidad"
    },
    cycles: {
        "custom-term": "{term} personalizados",
        "archived-term": "{term} archivados",
        abbreviation: "Abreviatura",
        minutes: "Minutos",
        "metres-to-advance": "Metros a avanzar",
        "must-be-greater-than-or-equal-to-0": "Debe ser mayor o igual a 0",
        "metres-to-advance-hint": "Cuánto avanzará este ciclo una ubicación. Deje en blanco o establezca en cero para cortes en tira, etc.",
        "text-colour": "Color del texto",
        sample: "Muestra:",
        "fire-tasks-cannot-change-default-duration": "Las tareas de voladura no pueden cambiar su duración predeterminada"
    },
    default: {
        "please-select-a-shift-to-begin": "Seleccione un turno para comenzar"
    },
    "department-creation-wizard": {
        "cycle-name": "Nombre del ciclo",
        "cycle-name-plural": "Nombre del ciclo (plural)",
        "enforce-cycles-on-development-board": "¿Aplicar ciclos en el tablero de desarrollo?",
        "intended-use": "Uso previsto",
        "location-name": "Nombre de la ubicación",
        "location-name-abbreviation": "Nombre de la ubicación (abreviatura)",
        "location-name-plural": "Nombre de la ubicación (plural)",
        "locations-in-resource-planning": "¿Ubicaciones en la planificación de recursos?",
        "show-on-mine-interaction-board": "¿Mostrar en el tablero de interacción de la mina?",
        general: "General",
        "use-for-general-mining-activities-including-development-production-and-services": "Usar para actividades mineras generales, incluyendo Desarrollo, Producción y Servicios.",
        maintenance: "Mantenimiento",
        "use-for-maintenance-activities": "Usar para actividades de mantenimiento.",
        note: "Nota:",
        config: "Configuración",
        "departments-require-some-specific-configuration-based-on-tasks-no-tasks-exist-for-this-department-yet-configure-tasks-and-then-update-this-department": "Los departamentos requieren cierta configuración específica según las tareas. Aún no existen tareas para este departamento. Configure las tareas y luego actualice este departamento"
    },
    departments: {
        "cut-number-priority-cutoff": "Límite de prioridad del número de corte",
        "cycle-name": "Nombre del ciclo",
        "cycle-name-plural": "Nombre del ciclo (plural)",
        "enforce-cycles-on-development-board": "¿Aplicar ciclos en el tablero de desarrollo?",
        "eos-task": "¿Tarea de fin de turno?",
        "intended-use": "Uso previsto",
        "location-name": "Nombre de la ubicación",
        "location-name-abbreviation": "Nombre de la ubicación (abreviatura)",
        "location-name-plural": "Nombre de la ubicación (plural)",
        "locations-in-resource-planning": "¿Ubicaciones en la planificación de recursos?",
        "show-on-mine-interaction-board": "¿Mostrar en el tablero de interacción de la mina?",
        "sos-tasks": "¿Tareas de inicio de turno?",
        "task-type": "Tipo de tarea",
        note: "Nota:",
        config: "Configuración",
        "departments-require-some-specific-configuration-based-on-tasks-no-tasks-exist-for-this-department-yet-configure-tasks-and-then-update-this-department": "Los departamentos requieren cierta configuración específica según las tareas. Aún no existen tareas para este departamento. Configure las tareas y luego actualice este departamento",
        "hide-cut-number-chainage-hint": "Ocultar el número de corte y la información de cadenamiento de los tableros para ubicaciones con prioridad mayor que esta. Deje en blanco para mostrar en todas las ubicaciones.",
        "short-code": "Código corto"
    },
    "edit-blast-packet-dialog-v2": {
        "duration-minutes": "Duración (minutos)",
        minutes: "Minutos",
        stope: "Cámara",
        "adding-additional-rings-to-a-blast-packet-is-not-supported": "No se admite agregar anillos adicionales a un paquete de voladura.",
        "enter-blast-packet-design-details": "Ingrese los detalles de diseño del paquete de voladura",
        "edit-blast-packet-dialog": "Editar cuadro de diálogo del paquete de voladura",
        "no-additional-levels-add-some-below": "No hay niveles adicionales, añada algunos abajo",
        "term-bog-task": "Tarea de extracción de {term}",
        "tolerance-percent": "Tolerancia (%)"
    },
    "edit-equipment-dialog": {
        image: "Imagen",
        type: "Tipo",
        "show-conflicts": "Mostrar conflictos",
        "select-departments": "Seleccionar {term}",
        "equipment-has-activities-cannot-delete": "Este equipo tiene actividades planificadas o ha sido asignado a otro equipo y no se puede eliminar."
    },
    "edit-to-do-action-sheet": {
        description: "Descripción",
        scope: "Alcance",
        title: "Título",
        "creating-task-mine-area-visible": "Crear una tarea en el área de la mina la hará visible en todos los departamentos.",
        "cannot-add-or-edit-tasks-whilst-offline": "No se pueden añadir ni editar tareas sin conexión."
    },
    "equipment-downtime-codes": {
        code: "Código",
        order: "Orden",
        "downtime-code": "Código de inactividad",
        "archived-downtime-codes": "Códigos de inactividad archivados",
        "codes-reordered": "Códigos reordenados"
    },
    "equipment-location-creation-wizard": {
        "select-term-to-plan": "Seleccione {term} para planificar.",
        "ignores-start-of-shift-tasks": "¿Ignora las tareas de inicio de turno?",
        "independent-end-of-shift": "¿Fin de turno independiente?",
        priority: "Prioridad",
        "an-archived-equipment-location-exists-with-this-name-have-you-considered-restoring-it-instead-of-creating-a-new-one": "Ya existe una ubicación de equipo archivada con este nombre. ¿Ha considerado restaurarla en lugar de crear una nueva?"
    },
    "equipment-roles": {
        "archived-term": "{term} archivados",
        "standard-term": "{term} estándar.",
        "crew-type": "Tipo de personal",
        "supports-special-display-options": "Admite opciones de visualización especiales en los paquetes de impresión, p. ej. tareas del personal de servicio."
    },
    "export-actual-physicals": {
        "from-time": "Hora desde",
        "export-physicals-range": "Exportar rango de físicos",
        all: "Todos",
        "last-90-days": "Últimos 90 días",
        custom: "Personalizado",
        "export-physicals": "Exportar físicos",
        "to-time": "Hora hasta",
        "from-time-before-to-time": "La hora desde debe ser anterior a la hora hasta."
    },
    "filtered-select": {
        search: "Buscar"
    },
    "generate-reporting-months-dialog": {
        "generate-calendar-months": "Generar meses del calendario",
        "target-year": "Año objetivo",
        "template-year": "Año plantilla",
        "use-template-year": "Usar año plantilla",
        generate: "Generar",
        "year-must-be-4-digits": "El año debe tener 4 dígitos",
        "add-reporting-months": "Añadir meses de reporte",
        "template-year-not-same-as-target": "El año plantilla no debe ser el mismo que el año objetivo."
    },
    "hazard-categories": {
        description: "Descripción",
        order: "Orden",
        "short-name": "Nombre corto",
        category: "Categoría",
        "archived-downtime-codes": "Códigos de inactividad archivados",
        "categories-reordered": "Categorías reordenadas"
    },
    "hazard-notes-sheet": {
        "hazards-for": "Peligros - {name}",
        "add-new-hazard": "Añadir nuevo peligro",
        "add-hazard": "Añadir peligro",
        "cannot-remove-hazards-from-other-departments": "No se pueden quitar peligros de otros departamentos.",
        "undo-removal": "Deshacer eliminación",
        "remove-hazard": "Quitar peligro",
        "marked-for-removal": "(Marcado para eliminación)",
        "reported-from-ordo-connect": "Reportado desde ORDO Connect",
        "new-hazards": "Nuevos peligros",
        "removing-hazards-not-supported-offline": "No se admite quitar peligros sin conexión. Solo se añadirán los nuevos peligros si guarda ahora.",
        "abandon-hazard-changes-message": "Ha actualizado los peligros pero debe presionar el botón \"Guardar\" para guardar los cambios. ¿Está seguro de que desea descartarlos?",
        "discard-partial-hazard-message": "Ha ingresado parcialmente un peligro, pero no lo ha añadido. ¿Está seguro de que desea descartarlo?"
    },
    "heading-details": {
        priority: "Prioridad",
        "survey-memo": "Memo de topografía",
        "ground-support-profile": "Perfil de sostenimiento del terreno",
        "term-plan": "Plan de {term}",
        "cannot-edit-whilst-offline": "No se puede editar sin conexión.",
        "must-have-week-planner-role": "Debe tener la función de planificador semanal.",
        unavailable: "No disponible",
        "unavailability-reason": "Motivo de indisponibilidad",
        details: "Detalles",
        "variance-to-plan-comments": "Comentarios de variación (respecto al plan)",
        "add-note": "Añadir nota",
        "add-hazard": "Añadir peligro",
        "abandon-location-changes-message": "Ha actualizado la información de la ubicación pero debe presionar el botón \"Guardar\" para guardar los cambios. ¿Está seguro de que desea descartarlos?",
        "please-select-image-or-pdf": "Seleccione un archivo de imagen o PDF"
    },
    "icon-selector": {
        icon: "Icono",
        search: "Buscar"
    },
    "import-equipments-availability-plan": {
        from: "Desde",
        review: "Revisar",
        "service-type": "Tipo de servicio",
        "starts-at": "Comienza a las",
        "ends-at": "Termina a las",
        "import-equipment-availability-plan": "Importar plan de disponibilidad de equipos",
        "existing-data-found-between-provided-date-range-will-be-replaced-or-removed": "Los datos existentes dentro del rango de fechas proporcionado serán reemplazados o eliminados",
        "existing-data-that-overlap-provided-date-range-below-will-be-affected": "Los datos existentes que se superpongan con el rango de fechas proporcionado a continuación se verán afectados",
        "imported-data-that-is-not-between-provided-date-range-below-will-be-skipped": "Los datos importados que no estén dentro del rango de fechas proporcionado a continuación serán omitidos",
        to: "Hasta:"
    },
    "import-key-physical-targets-dialog": {
        line: "Línea {number}",
        "from-date": "Fecha desde",
        "select-month": "Seleccionar mes",
        "unknown-target-type": "Tipo de objetivo desconocido",
        "import-key-physical-targets": "Importar objetivos físicos clave",
        validate: "Validar",
        "import-file-details": "Detalles del archivo de importación",
        "import-for-term": "Importar para {term}",
        "aid-in-importing-download-template": "Para ayudar en la importación de objetivos, descargue la plantilla.",
        "each-line-single-target": "Cada línea del archivo de importación corresponde a un único objetivo.",
        "detail-shift": ": El número de turno para el objetivo.",
        date: "Fecha",
        "detail-date": ": La fecha del objetivo en formato AAAA-MM-DD.",
        target: "Objetivo",
        "detail-target": ": El valor del objetivo.",
        "target-type": "Tipo de objetivo",
        "detail-target-type": ": El tipo de objetivo (p. ej. Metros Avanzados, Voladuras). Para tipos de objetivo personalizados, use el nombre establecido en administración.",
        "import-for-month": "Importar para el mes",
        "year-not-found": "Año no encontrado en los años de reporte. Genérelo aquí o créelo manualmente.",
        "generate-calendar-year": "Generar año calendario",
        "copy-previous-year": "Copiar año anterior",
        "import-issues-resolve": "Hay uno o más problemas con su importación. Resuélvalos antes de continuar",
        "target-type-label": "Tipo de objetivo:",
        "target-shift-label": "Turno objetivo:",
        "target-date-label": "Fecha objetivo:",
        "target-value-label": "Valor objetivo:",
        "import-may-have-issues": "Puede haber habido problemas con su importación",
        "unknown-error": "Error desconocido"
    },
    "import-staff-availability-plan": {
        from: "Desde",
        review: "Revisar",
        type: "Tipo",
        "import-staff-availability-plan": "Importar plan de disponibilidad de personal",
        "existing-data-found-between-provided-date-range-will-be-replaced-or-removed": "Los datos existentes dentro del rango de fechas proporcionado serán reemplazados o eliminados",
        "imported-data-that-is-not-between-provided-date-range-below-will-be-skipped": "Los datos importados que no estén dentro del rango de fechas proporcionado a continuación serán omitidos",
        "import-leave-records": "Importar registros de ausencia",
        "import-overtime-records": "Importar registros de horas extra",
        "error-importing-plan": "Hubo un error al importar su plan de disponibilidad de personal",
        "plan-saved-successfully": "Plan de disponibilidad de personal guardado correctamente"
    },
    "inspection-categories": {
        description: "Descripción",
        order: "Orden",
        "short-name": "Nombre corto",
        "show-most-recent": "Mostrar más reciente",
        category: "Categoría",
        "archived-categories": "Categorías archivadas",
        "categories-reordered": "Categorías reordenadas"
    },
    "levelled-resources": {
        "resource-under-utilisation": "Subutilización de recursos (%)",
        "levelled-resources": "Recursos nivelados",
        "must-be-less-than-resource-level-target": "Debe ser menor que el objetivo de nivel de recursos.",
        "archived-resources": "Recursos archivados",
        "utilisation-under-flagged": "Los porcentajes de utilización por debajo de este valor serán señalados.",
        "resource-level-target": "Objetivo de nivel de recursos (%)",
        "must-be-greater-than-resource-under-utilisation": "Debe ser mayor que la subutilización de recursos.",
        "utilisation-over-flagged": "Los porcentajes de utilización por encima de este valor serán señalados.",
        "tooltime-minutes": "Tiempo de herramienta (minutos)",
        "minutes-per-shift-explanation": "Minutos por turno que se espera que un miembro del personal de este recurso pueda trabajar.",
        "suggest-assignments": "Sugerir asignaciones",
        "assigned-task-types": "Tipos de tarea asignados",
        "assigned-staff-roles": "Funciones de personal asignadas",
        "resources-reordered": "Recursos reordenados"
    },
    "location-commentary-sheet": {
        "notes-for": "Notas - {title}",
        "show-previous-notes": "Mostrar {count} {noteWord} anteriores",
        comment: "Comentario",
        "save-note": "Guardar nota",
        "discard-changes": "Descartar cambios",
        "no-notes": "Sin notas",
        "cannot-add-or-alter-notes-if-offline": "No se pueden añadir ni modificar notas sin conexión",
        "edit-notes": "Editar notas",
        "add-note": "Añadir nota",
        "no-history": "Sin historial"
    },
    "location-creation-wizard": {
        "default-cycle": "Ciclo predeterminado",
        "ignores-start-of-shift-tasks": "¿Ignora las tareas de inicio de turno?",
        "independent-end-of-shift": "¿Fin de turno independiente?",
        "parent-location": "Ubicación principal",
        priority: "Prioridad",
        "start-cut-number": "Número de corte inicial",
        status: "Estado",
        development: "Desarrollo",
        "use-for-development-work": "Usar para trabajos de desarrollo.",
        "ad-hoc": "Ad-Hoc",
        "use-for-ad-hoc-operations-like-services": "Usar para operaciones ad-hoc como servicios.",
        stoping: "Rebaje",
        "use-for-all-stopes": "Usar para todos los rebajes.",
        "stoping-subheading": "Rebaje - Subfrente",
        "use-for-stope-children": "Usar para elementos secundarios del rebaje.",
        "sub-level-caving": "Hundimiento por subniveles",
        "use-for-sub-level-caving": "Usar para hundimiento por subniveles.",
        "an-archived-location-exists-with-this-name-have-you-considered-restoring-it-instead-of-creating-a-new-one": "Ya existe una ubicación archivada con este nombre. ¿Ha considerado restaurarla en lugar de crear una nueva?",
        "bogging-horizon": "Horizonte de extracción",
        "must-be-positive-integer": "Debe ser un número entero positivo"
    },
    "location-tracker": {
        "show-completed-term": "Mostrar {term} completadas",
        "could-not-find-tarp": "No se pudo encontrar el TARP con id {id}",
        "material-destination": "Destino del material",
        "material-type": "Tipo de material",
        stockpile: "Acopio",
        "stockpile-status": "Estado del acopio",
        completed: "completado",
        archived: "Archivado",
        "tracker-board": "Tablero de seguimiento",
        "location-status": "Estado de la ubicación"
    },
    locations: {
        "allows-planning-against-equipment": "Permite planificar tareas contra {equipment} en lugar de una {location}.",
        "standard-term": "{term} estándar.",
        "add-child-term": "Agregar una {term} secundaria.",
        "archived-term": "{term} archivadas",
        "child-term-saved": "{term} secundaria guardada",
        "cycle-type": "Tipo de ciclo",
        "default-cycle": "Ciclo predeterminado",
        "ignores-start-of-shift-tasks": "¿Ignora las tareas de inicio de turno?",
        "independent-end-of-shift": "¿Fin de turno independiente?",
        level: "Nivel",
        "mining-method": "Método de minería",
        priority: "Prioridad",
        "start-cut-number": "Número de corte inicial",
        status: "Estado",
        "cannot-import-no-reduced-levels-available-for-this-mine-area": "No se puede importar: No hay niveles reducidos disponibles para esta área de mina.",
        "this-location-has-activities-planned-and-cannot-be-deleted": "Esta ubicación tiene actividades planificadas y no se puede eliminar.",
        "must-be-a-positive-integer": "Debe ser un número entero positivo"
    },
    "material-destinations": {
        abbreviation: "Abreviatura"
    },
    "material-types": {
        abbreviation: "Abreviatura"
    },
    "meeting-guide": {
        search: "Buscar",
        "shift-deployment": "Despliegue de turno",
        "shift-handover": "Entrega de turno",
        "shift-interactions": "Interacciones de turno"
    },
    "mine-areas": {
        "first-day-of-week": "Primer día de la semana",
        "first-shift-starts-at": "El primer turno comienza a las",
        "shift-overlap-minutes": "Solapamiento de turnos (minutos)",
        "shift-schedule": "Horario de turnos",
        "shifts-per-day": "Turnos por día",
        "start-counting-weeks-from": "Comenzar a contar semanas desde",
        "temperature-scale": "Escala de temperatura",
        "shift-timings": "Horarios de turno",
        updating: "Actualizando...",
        "change-temperature-scale": "Cambiar escala de temperatura",
        "time-zone": "Zona horaria",
        "shift-1-name": "Nombre del turno 1",
        "shift-2-name": "Nombre del turno 2",
        "shift-3-name": "Nombre del turno 3",
        "shift-4-name": "Nombre del turno 4",
        logo: "Logo",
        sending: "Enviando...",
        "upload-logo": "Subir logo",
        "logo-dimensions-hint": "Los logos deberían tener idealmente 74 píxeles de alto y no más de 250 píxeles de ancho. Para mostrarse sobre un fondo blanco. Solo PNG",
        "location-name-convention": "Convención de nombres de ubicación",
        "bad-format": "Formato incorrecto",
        "location-convention-hint": "A = letra, N = dígito, . = Cualquier cosa, * = Muchos. Ej. `A._N*` o `.* A*`",
        "show-help": "Mostrar ayuda",
        "test-location-pattern": "Probar patrón de ubicación",
        "enter-location-name-to-test": "Ingrese un nombre de ubicación para probar",
        "location-pattern-help": "A = 1 letra         A* = muchas letras\nN = 1 número         N* = muchos números\n? = 1 letra o núm  ?* = muchas letras o números\n. = cualquier 1 carácter  .* = muchos caracteres\n\nOtros símbolos permitidos: - _ / y espacios\nej. `A._D*` coincide con H2_123 y HA_444",
        "hide-help": "Ocultar ayuda",
        configuration: "Configuración",
        "shift-overlap-mins": "Solapamiento de turnos (min)",
        "location-names": "Nombres de ubicación",
        "temperature-scale-updated": "Escala de temperatura actualizada",
        "failed-to-update-temperature-scale": "No se pudo actualizar la escala de temperatura",
        "please-select-image-or-pdf-file": "Por favor, seleccione un archivo de imagen o PDF"
    },
    "move-rings-from-blast-packet-dialog": {
        "source-extraction": "Extracción de origen {unit}",
        "target-extraction": "Extracción de destino {unit}",
        "blast-packet": "Paquete de voladura",
        "rings-to-move": "Anillos a mover",
        tolerance: "Tolerancia (%)",
        move: "Mover",
        "i-acknowledge-that-this-will-leave-the-blast-packet-with-no-rings-deleting-it": "Reconozco que esto dejará el paquete de voladura sin anillos, eliminándolo",
        "move-rings-dialog": "Cuadro de diálogo para mover anillos",
        "move-title": "Mover {items} de {source}",
    },
    "multiple-filtered-select": {
        search: "Buscar",
        "select-all": "Seleccionar todo"
    },
    "pending-sync-warning-dialog": {
        "navigate-with-pending-count": "El usuario intentó navegar con {count} solicitudes pendientes en cola a las {timestamp}",
        "unsaved-changes": "Cambios sin guardar",
        "continue-working": "Continuar trabajando",
        "schedule-changes-are-still-being-saved-to-the-server": "Los cambios de programación aún se están guardando en el servidor."
    },
    "planning-drawer-actions": {
        "show-blast-packet-tasks": "Mostrar tareas del paquete de voladura"
    },
    "plod-entry": {
        "show-term": "Mostrar {term}",
        "error-deleting-term": "Error al eliminar {term}",
        "error-populating-actuals-from-shift-plan": "Error al rellenar los datos reales desde el plan de turno: {error}",
        "error-marking-reportable": "Error al marcar los datos reales como listos para informar: {error}",
        "error-marking-not-reportable": "Error al marcar los datos reales como no listos para informar: {error}",
        "error-copying-task-times": "Error al copiar los horarios de tareas desde el plan de turno: {error}",
        "error-loading-operator-completion": "Error al cargar la información de finalización del operador: {error}",
        "error-loading-rejected-tasks": "Error al cargar las tareas rechazadas: {error}",
        equipment: "Equipo",
        formula: "Fórmula",
        plods: "Plods",
        duplicates: "Duplicados",
        "sync-times": "Tiempos de sincronización",
        complete: "% Completado",
        "task-type": "Tipo de tarea",
        operator: "Operador",
        "show-delays": "Mostrar retrasos",
        "view-operator-plod-completion-information": "Ver información de finalización de PLOD del operador.",
        "view-potential-duplicates": "Ver posibles duplicados.",
        "pull-start-and-end-times": "Obtener las horas de inicio y fin de las entradas desde el plan de turno.",
        "add-plod-entry": "Añadir entrada de PLOD",
        "undo-completion": "Deshacer finalización",
        "no-actuals-data-found": "No se encontraron datos reales que coincidan con este turno y los criterios de filtro.",
        "populate-data-for-shift": "Completar datos del turno",
        "sort-by-up-to-3-columns": "Ordenar por hasta 3 columnas",
        column: "Columna",
        direction: "Dirección",
        "add-level": "Añadir nivel",
        apply: "Aplicar",
        "task-type-column": "Tarea (Tipo)",
        "cut-number": "Corte n.º",
        "start-chainage-m": "Cadenamiento inicial (m)",
        "end-chainage-m": "Cadenamiento final (m)",
        "start-time": "Hora de inicio",
        "end-time": "Hora de fin",
        "percentage-of-task-completed": "Porcentaje de la tarea completada durante este turno.",
        ignore: "Ignorar",
        "row-will-not-save-until-task-type": "La fila no se guardará hasta que se seleccione el Tipo de tarea.",
        "represents-actuals-same-piece-of-work": "Representa los valores reales asociados todos con la misma tarea de trabajo.",
        "reported-from-ordo-connect": "Reportado desde ORDO Connect.",
        "add-plod-entry-for-piece-of-work": "Añadir una entrada de PLOD para esta tarea de trabajo.",
        "display-name": "Nombre para mostrar",
        "enter-comments-here": "Ingrese comentarios aquí...",
        "ignore-row-for-reporting": "Ignorar esta fila para los informes (usar para ingresar datos duplicados).",
        totals: "Totales",
        "rejected-tasks": "Tareas rechazadas",
        "plod-completion": "Finalización de PLOD",
        "viewing-potential-duplicates-read-only": "Viendo posibles duplicados - Solo lectura",
        "undo-deletion": "Deshacer eliminación",
        "actuals-populated-from-shift-plan": "Valores reales completados desde el plan de turno",
        "error-processing-formula": "Error al procesar la fórmula: ",
        "please-fix-validation-errors": "Por favor, corrija los errores de validación antes de guardar.",
        "cancel-reportability": "Cancelar reportabilidad",
        "confirm-mark-not-ready": "¿Está seguro de que desea marcar estos PLOD como no listos para reportar?",
        "mark-reportable": "Marcar como reportable",
        "confirm-mark-ready": "¿Está seguro de que desea marcar estos PLOD como listos para reportar?",
        "changes-still-possible": "Aún podrá realizar cambios después de hacerlo.",
        "marked-reportable": "Marcado como reportable",
        "marked-not-reportable": "Marcado como no reportable",
        "cannot-enter-both-cut-and-chainage": "No se pueden ingresar valores de Corte n.º y cadenamiento a la vez. Utilice Corte n.º o Cadenamiento inicial/final.",
        "both-chainage-together": "El Cadenamiento inicial y el Cadenamiento final deben ingresarse juntos, o ninguno de los dos.",
        "end-chainage-greater-than-start": "El Cadenamiento final debe ser mayor que el Cadenamiento inicial.",
        "task-times-copied": "Horas de tareas copiadas del plan de turno",
        "copy-task-times": "Copiar horas de tareas",
        "confirm-copy-task-times": "¿Está seguro de que desea copiar las horas de tareas del plan de turno?"
    },
    "production-front-locations-dialog": {
        search: "Buscar",
        select: "Seleccionar",
        "select-all": "Seleccionar todo",
        "replace-existing-locations": "Reemplazar {term} existentes"
    },
    "production-front-overlays-dialog": {
        "rotation-degrees": "Rotación (grados)",
        scale: "Escala",
        "x-offset": "Desplazamiento X",
        "y-offset": "Desplazamiento Y",
        overlays: "Superposiciones",
        "overlay-saved": "Superposición guardada"
    },
    "production-fronts": {
        "charge-sleep-expiry-days": "Caducidad de carga en reposo (días)",
        department: "Departamento",
        "drill-charge-rule-distance": "Distancia de regla de perforación-carga",
        "inter-level-drilling-rule-distance": "Distancia de regla de perforación entre niveles",
        "intra-level-drilling-rule-distance": "Distancia de regla de perforación dentro del nivel",
        "maximum-lag-distance": "Distancia máxima de retraso",
        "maximum-lead-distance": "Distancia máxima de adelanto",
        "maximum-tonnes-bogged": "Toneladas máximas cargadas",
        "drill-charge-inter-level-rule": "Regla inter-nivel de perforación/carga",
        "drill-intra-level-rule": "Regla intra-nivel de perforación",
        "drill-intralevel-rule": "Regla intranivel de perforación",
        "charge-sleep-expiry-rule": "Regla de vencimiento de reposo de carga",
        "drawpoint-tonnes-bogged": "Toneladas extraídas del punto de extracción",
        "drawpoint-lead-lag-ring-distances": "Distancias de anillos adelanto-retraso del punto de extracción",
        "import-coordinates": "Importar coordenadas",
        "cannot-import-no-department-or-front": "No se puede importar la información del diagrama cuando no se selecciona ningún {term0} o {term1}"
    },
    "property-definition-dialog": {
        "new-value": "nuevo valor {number}",
        "display-order": "Orden de visualización",
        type: "Tipo",
        value: "valor",
        "accepted-values": "Valores aceptados",
        "property-definition": "Definición de propiedad"
    },
    reporting: {
        department: "Departamento",
        description: "Descripción",
        "equipment-role": "Función del equipo",
        label: "Etiqueta",
        "last-incident-date": "Fecha del último incidente",
        "linked-actuals-definitions": "Definiciones de valores reales vinculadas",
        metric: "Métrica",
        "sub-category-name": "Nombre de la subcategoría",
        value: "Valor",
        reporting: "Informes",
        "physical-target-type": "Tipo de objetivo físico",
        "tracked-event-type": "Tipo de evento rastreado",
        "sub-categories": "Subcategorías",
        "tracked-count-type": "Tipo de conteo rastreado",
        "tracked-days-since-last-incident-type": "Tipo de días rastreados desde el último incidente",
        "select-an-equipment-role-for-the-department-daily-report-configuration-this-role-will-be-used-for-blast-info-first-work": "Seleccione una función de equipo para la configuración del informe diario del departamento. Esta función se usará para el primer trabajo de información de voladura.",
        "report-headers": "Encabezados del informe",
        "equipment-role-and-headers": "Función del equipo y encabezados",
        "import-reporting-calendar": "Importar calendario de reporte",
        "export-reporting-calendar": "Exportar calendario de reporte",
        "warning-this-target-type-may-not-function-correctly-without-at-least-one-actuals-definition": "Advertencia: Este tipo de objetivo puede no funcionar correctamente sin al menos una definición de datos reales.",
        "as-this-is-a-system-defined-target-type-it-is-not-possible-to-associate-this-manually-to-actuals": "Como este es un tipo de objetivo definido por el sistema, no es posible asociarlo manualmente a los datos reales.",
        "this-physical-target-type-is-in-use-and-cannot-be-deleted": "Este tipo de objetivo físico está en uso y no se puede eliminar.",
        "this-physical-target-type-is-system-defined-and-cannot-be-deleted": "Este tipo de objetivo físico está definido por el sistema y no se puede eliminar.",
        "this-count-type-is-archived-you-can-restore-it-using-the-restore-button-in-the-list": "Este tipo de conteo está archivado. Puede restaurarlo utilizando el botón de restaurar en la lista.",
        "this-incident-type-is-archived-you-can-restore-it-using-the-restore-button-in-the-list": "Este tipo de incidente está archivado. Puede restaurarlo utilizando el botón de restaurar en la lista.",
        "the-last-incident-date-can-only-be-set-when-creating-the-type-you-can-update-it-in-the-data-table-after-creation": "La fecha del último incidente solo se puede establecer al crear el tipo. Puede actualizarla en la tabla de datos después de la creación.",
        "configure-report-equipment-and-headers": "Configurar equipo y encabezados del reporte",
        "reporting-calendar": "Calendario de reporte",
        "physical-target-types": "Tipos de objetivo físico",
        "import-key-physical-targets": "Importar objetivos físicos clave",
        "system-defined": "Definido por el sistema",
        "tracked-event-types": "Tipos de evento rastreado",
        "tracked-count-types": "Tipos de conteo rastreado",
        "tracked-days-since-last-incident-types": "Tipos de días rastreados desde el último incidente",
        "no-sub-categories-defined": "No hay subcategorías definidas. Haga clic en \"Añadir\" para crear subcategorías.",
        "event-type-archived-hint": "Este tipo de evento está archivado. Puede restaurarlo utilizando el botón de restaurar en la lista.",
        "add-report-header": "Añadir encabezado del informe",
        "cannot-have-more-than-2-headers": "No se pueden tener más de 2 encabezados",
        "weekly-target": "Objetivo semanal",
        "daily-target": "Objetivo diario",
        "weight-t": "Peso (t)",
        "weight-kg": "Peso (kg)",
        "invalid-sub-categories": "Subcategorías no válidas",
        "all-sub-categories-must-have-a-name": "Todas las subcategorías deben tener un nombre. Proporcione nombres para todas las subcategorías o elimine las vacías.",
        "archive-event-type": "Archivar tipo de evento",
        "confirm-archive-event-type": "¿Está seguro de que desea archivar este tipo de evento?",
        "restore-event-type": "Restaurar tipo de evento",
        "confirm-restore-event-type": "¿Está seguro de que desea restaurar este tipo de evento?",
        "archive-count-type": "Archivar tipo de conteo",
        "confirm-archive-count-type": "¿Está seguro de que desea archivar este tipo de conteo?",
        "restore-count-type": "Restaurar tipo de conteo",
        "confirm-restore-count-type": "¿Está seguro de que desea restaurar este tipo de conteo?",
        "archive-incident-type": "Archivar tipo de incidente",
        "confirm-archive-incident-type": "¿Está seguro de que desea archivar este tipo de incidente?",
        "restore-incident-type": "Restaurar tipo de incidente",
        "confirm-restore-incident-type": "¿Está seguro de que desea restaurar este tipo de incidente?"
    },
    "resolve-conflict-dialog": {
        comments: "Comentarios",
        resolved: "Resuelto",
        "jump-to-department": "Ir al departamento:"
    },
    resources: {
        "primary-equipment-utilisation": "Porcentaje de utilización de {term} primario en este turno",
        "secondary-equipment-utilisation": "Porcentaje de utilización de {term} secundario en este turno",
        "support-equipment-utilisation": "Porcentaje de utilización de {term} de apoyo en este turno",
        "task-not-found": "No se encontró la tarea para la ubicación {location} y la tarea {task}",
        "show-unused": "Mostrar sin usar",
        button: {
            "add-crew-role": "Añadir función de personal",
            "copy-previous": "Copiar anterior",
            "clear-staff": "Borrar personal",
            "unplanned-leave": "Ausencia no planificada"
        },
        heading: {
            "assigned-resources": "Recursos asignados",
            "assigned-roles": "Funciones asignadas",
            "availability-for": "Disponibilidad para {name}",
            "comments-for": "Comentarios para {name}",
            crews: "Personal de turno",
            "primary-equipment": "Equipo principal",
            resources: "Recursos",
            "secondary-equipment": "Equipo secundario",
            "support-equipment": "Equipo de apoyo",
            "clear-staff-confirm-prompt": "Borrar personal",
            "add-crew-member": "Añadir miembro del personal",
            "add-crew-role": "Añadir función de personal"
        },
        label: {
            "current-location": "Ubicación actual",
            "no-tasks": "Sin tareas",
            unassigned: "Sin asignar",
            "equipment-filtered": "Equipo no visible debido a los filtros aplicados"
        },
        message: {
            "no-crew-selected": "No hay personal seleccionado",
            "clear-staff-confirmation": "Se borraron todas las asignaciones de personal.",
            "clear-staff-confirm-prompt": "¿Está seguro de que desea borrar todas las asignaciones de personal?",
            "no-secondary-equipment-assigned": "No hay equipo secundario asignado",
            "nothing-to-copy": "Nada que copiar: no se encontró ningún turno anterior para este departamento con el mismo personal seleccionado: {crewNames}",
            "unplanned-leave-confirm": "Confirmar ausencia no planificada para el turno",
            "copy-previous": "Asignaciones copiadas del turno anterior"
        },
        "hide-unavailable-term": "Ocultar {term} no disponible",
        "copy-previous-allocations": "Copiar asignaciones anteriores",
        "copy-previous-shift-allocations": "¿Copiar asignaciones del turno anterior?",
        yes: "Sí",
        "primary-term": "{term} principal",
        "secondary-term": "{term} secundario",
        "support-term": "{term} de apoyo",
        "changing-crews-will-clear-assigned-roles": "Cambiar de equipo borrará las funciones asignadas",
        "resource-utilisation": "Utilización de recursos",
        "percentage-utilisation-of-crew-members": "Porcentaje de utilización de los miembros del personal en este turno",
        "staff-member-no-levelled-resource": "El miembro del personal no tiene un recurso nivelado asignado. Asígnelo directamente a las tareas.",
        "staff-member-no-matching-tasks": "El miembro del personal no coincide con ninguna tarea por recurso nivelado. Asígnelo directamente a las tareas."
    },
    "ring-design-generation-dialog": {
        "display-order-in-use": "El orden de visualización {displayOrder} ya está en uso. Al usarlo se insertará este anillo en esa posición.",
        "charge-distance": "Distancia de carga",
        "drill-distance": "Distancia de perforación",
        "extraction-amount": "Cantidad de extracción",
        "hole-name": "Nombre del barreno",
        "ring-order": "Orden del anillo",
        "select-number-of-holes": "Seleccionar número de barrenos",
        "select-ring-template": "Seleccionar plantilla de anillo",
        generate: "Generar",
        reset: "Restablecer",
        "add-hole": "Añadir barreno",
        "must-have-at-least-one-hole": "Debe tener al menos un barreno"
    },
    sandpit: {
        "department-name": "Departamento: {name}",
        "setup-week-plan-with-adjacent": "Configure el plan semanal del departamento para esta semana {asAt}, junto con los planes de las semanas anterior y siguiente ",
        "setup-week-plan": "Configure el plan semanal del departamento para esta semana {asAt} ",
        "blast-packets": "Paquetes de voladura",
        "comms-fields": "Campos de comunicaciones",
        crews: "Personal de turno",
        cycles: "Ciclos",
        equipment: "Equipo",
        "last-week-plan-template": "Plantilla del plan de la semana pasada",
        levels: "Niveles",
        locations: "Ubicaciones",
        "next-week-plan-template": "Plantilla del plan de la próxima semana",
        overlays: "Superposiciones",
        rings: "Anillos",
        "scenario-directory": "Directorio de escenarios",
        "select-all-files-for-specific-scenarios": "Seleccionar todos los archivos para escenarios específicos",
        "select-all-visualisation-overlay": "Seleccionar toda la superposición de visualización",
        tarps: "TARPs",
        "task-types": "Tipos de tarea",
        "visualisation-co-ordinates": "Coordenadas de visualización",
        "week-plan-template": "Plantilla del plan semanal",
        "manage-the-sandpit-mine-area": "Gestionar el área de mina del entorno de pruebas",
        "long-running-action": "Acción de larga duración",
        "import-all": "Importar todo",
        "populate-sandpit-data": "Rellenar datos del entorno de pruebas",
        "setup-the-sandpit-mine-area-with-data-from-import-files": "Configurar el área de mina del entorno de pruebas con datos de archivos de importación",
        "manage-department-data": "Gestionar datos del departamento",
        "setup-the-sandpit-department-with-department-specific-data": "Configurar el departamento del entorno de pruebas con datos específicos del departamento",
        "manage-week-plan": "Gestionar plan semanal",
        "manage-visualisation": "Gestionar visualización",
        "setup-the-departments-visualisation": "Configurar la visualización del departamento",
        "the-import-will-create-development-and-production-departments-this-can-take-approximately-15-minutes-to-complete": "- La importación creará departamentos de desarrollo y producción. Esto puede tardar aproximadamente 15 minutos en completarse.",
        "this-action-could-take-some-time-to-complete-it-is-creating-3-week-plans": "- Esta acción puede tardar algún tiempo en completarse. Está creando planes de 3 semanas",
        "creating-rings-and-blast-packets-can-take-some-time-to-complete": "- La creación de anillos y paquetes de voladura puede tardar algún tiempo en completarse",
        "creating-three-sub-level-caving-week-plans-can-take-approximately-5-10-minutes-to-complete": "- La creación de tres planes semanales de hundimiento por subniveles puede tardar aproximadamente 5-10 minutos en completarse.",
        "sandpit-loader": "Cargador de entorno de pruebas"
    },
    "shift-board-row": {
        "hide-unavailability-sign": "Ocultar señal de indisponibilidad",
        "show-unavailability-sign": "Mostrar señal de indisponibilidad",
        unavailable: "No disponible"
    },
    "shift-loader": {
        "shift-loader-name": "Cargador de turno: {name}",
        "planning-for-this-week-has-not-started-create": "La planificación de esta semana no ha comenzado. Cree un plan semanal antes de planificar este turno",
        "shift-loader": "Cargador de turno"
    },
    "shift-printer": {
        source: "Fuente",
        "print-shift-packs": "Imprimir paquetes de turno",
        "maintenance-shift-pack": "Paquete de turno de mantenimiento",
        "shift-pack": "Paquete de turno",
        "compressed-shift-pack": "Paquete de turno comprimido",
        "term-pack": "Paquete de {term}",
        "term-details": "Detalles de {term}",
        "download-csv": "Descargar CSV",
        "training-shift-pack": "Paquete de turno de capacitación",
        "blank-shift-plan": "Plan de turno en blanco",
        "current-plan": "Plan actual",
        "publish-shift": "¿Publicar turno?",
        "would-you-like-to-publish-baseline": "¿Desea publicar este turno como línea base?",
        "failed-to-publish-shift": "No se pudo publicar el turno.",
        "published-shift-as-baseline": "Turno publicado como línea base."
    },
    "shift-reports": {
        "this-shift-published-baseline": "Línea base publicada de este turno",
        "baseline-for-previous-shift-not-found": "No se encontró la línea base del turno anterior",
        "compare-last-24hr-actuals-to-published-plan": "Comparar valores reales de las últimas 24 h con el plan publicado",
        "shift-variance-report": "Informe de variación del turno",
        "previous-shift-published-baseline": "Línea base publicada del turno anterior",
        "variance-report": "Informe de variación",
        "current-plan": "Plan actual"
    },
    "shift-selector": {
        "week-commencing": "Semana {weekNumber} s/d {date} ",
        date: "Fecha",
        department: "Departamento",
        "mine-area": "Área de la mina",
        "select-shift": "Seleccionar turno...",
        select: "Seleccionar",
        "select-shift-title": "Seleccionar turno",
        "week-of": "Semana del",
        "mine-interactions-board": "Tablero de interacciones de la mina"
    },
    "shift-task-actions": {
        "add-task-after": "Añadir tarea después",
        "add-task-before": "Añadir tarea antes",
        "delete-task": "Eliminar tarea",
        "edit-quantity": "Editar cantidad",
        "edit-task": "Editar tarea",
        "send-to-next-shift": "Enviar al siguiente turno",
        "show-planned-targets": "Mostrar objetivos planificados",
        split: "Dividir",
        "switch-bogging-type": "Cambiar tipo de carga",
        "show-usage": "Mostrar uso de {term}"
    },
    "split-task-dialog": {
        "delay-duration": "Duración del retraso",
        "delay-type": "Tipo de retraso",
        "split-a-task-and-insert-a-delay": "Dividir una tarea e insertar un retraso",
        "split-task": "Dividir tarea",
        "can-t-split-tasks-which-are-shorter-than-45-minutes": "No se pueden dividir tareas de menos de 45 minutos."
    },
    "staff-roles": {
        "archived-term": "{term} archivados",
        supervisor: "¿Supervisor?"
    },
    "standard-dialog": {
        "could-not-load-the-required-data-for-this": "No se pudieron cargar los datos requeridos para este cuadro de diálogo"
    },
    stockpiles: {
        abbreviation: "Abreviatura",
        status: "Estado"
    },
    "subscribers-dialog": {
        "add-new-subscriber": "Añadir nuevo suscriptor",
        events: "Eventos",
        "notification-subscribers": "Suscriptores de notificaciones",
        "select-all": "Seleccionar todo",
        "weekly-board": "Tablero semanal",
        "must-not-match-existing-email": "No debe coincidir con un correo electrónico existente.",
        "confirm-abandon-partially-added": "Ha agregado parcialmente un nuevo suscriptor y debe presionar el botón \"Añadir\" para completar el proceso. ¿Está seguro de que desea abandonar los cambios?",
        "confirm-abandon-partially-updated": "Ha actualizado parcialmente un suscriptor y debe presionar el botón \"Actualizar\" para completar el proceso. ¿Está seguro de que desea abandonar los cambios?"
    },
    "supervisor-actuals-tab": {
        "add-term-variance": "Agregar variación de {term}",
        "heading-not-found": "No se encontró el encabezado con id de ubicación planificada {id}.",
        comment: "Comentario",
        location: "Ubicación",
        comments: "Comentarios",
        "variance-to-plan": "Variación respecto al plan",
        "add-variance-to-plan": "Añadir variación al plan",
        "remove-variance-reason": "Eliminar motivo de variación"
    },
    "supervisor-safety-and-incidents-tab": {
        location: "Ubicación",
        safety: "Seguridad",
        "add-safety-incident": "Añadir incidente de seguridad",
        "add-safety-observation": "Añadir observación de seguridad",
        "add-jsea": "Añadir JSEA",
        "add-condition-report": "Añadir informe de condición",
        incidents: "Incidentes",
        "add-condition-monitoring": "Añadir monitoreo de condición",
        "add-job-safety-environmental-analysis": "Añadir análisis de seguridad y medio ambiente del trabajo",
        "remove-incident": "Eliminar incidente",
        observations: "Observaciones",
        "remove-observation": "Eliminar observación",
        "remove-jsea": "Eliminar JSEA",
        "condition-monitoring": "Monitoreo de condiciones",
        "thermal-work-limit": "Límite de trabajo térmico",
        "wet-bulb-temp": "Temp. de bulbo húmedo",
        "dry-bulb-temp": "Temp. de bulbo seco",
        activity: "Actividad",
        "remove-condition-report": "Eliminar informe de condiciones",
        time: "Hora",
        "wet-bulb-temperature": "Temperatura de bulbo húmedo",
        "dry-bulb-temperature": "Temperatura de bulbo seco"
    },
    "task-categories": {
        "mine-area": "Área de la mina"
    },
    "task-group-actions": {
        accept: "Aceptar",
        "edit-task": "Editar tarea",
        "show-blast-packet-tasks": "Mostrar tareas del paquete de voladura"
    },
    "task-suggestion": {
        "duration-min": "Duración: {minutes} min ",
        "end-date": "Fecha de fin",
        "end-time": "Hora de fin",
        "planned-quantity": "Cantidad planificada",
        "start-date": "Fecha de inicio",
        "start-time": "Hora de inicio",
        "add-task": "Añadir tarea",
        "duration-must-be-greater-than-0": "La duración debe ser mayor que 0"
    },
    tasks: {
        "system-term": "{term} del sistema",
        "custom-term": "{term} personalizadas",
        "archived-term": "{term} archivadas",
        abbreviation: "Abreviatura",
        "category-type": "Tipo de categoría",
        department: "Departamento",
        "name-future-tense": "Nombre (tiempo futuro)",
        "name-when-in-progress": "Nombre cuando está en progreso",
        "system-task-class": "Clase de tarea del sistema",
        "naming-tasks": "Nombrando tareas",
        "future-tense-and-in-progress-are-the-names-used-to-refer-to-this-task-in-the-future-or-in-progress-e-g-for-bog-the-future-tense-would-be-to-bog-and-in-progress-would-be-bogging": "- 'tiempo futuro' y 'en progreso' son los nombres utilizados para referirse a esta tarea en el futuro o en progreso. Por ejemplo, para 'Bog' el tiempo futuro sería 'To Bog' y en progreso sería 'Bogging'",
        "this-a-system-setting-and-changing-this-will-have-system-wide-effects-changing-task-class-can-change-system-behaviour-this-is-an-administration-action-only": "- Esta es una configuración del sistema y cambiarla tendrá efectos en todo el sistema. Cambiar la clase de tarea puede cambiar el comportamiento del sistema. Esta es una acción exclusiva de administración.",
        "some-task-classes-removed": "Se han eliminado algunas clases de tareas de la lista, ya que están en uso.",
        "is-delay": "¿Es retraso?",
        "allocate-actuals-to-next-cut": "¿Asignar valores reales al siguiente corte?",
        "default-time-mins": "Tiempo predeterminado (min)",
        "delay-type": "Tipo de retraso",
        metric: "Métrica",
        "linked-physical": "Físico vinculado",
        "task-colour": "Color de la tarea",
        "text-colour": "Color del texto",
        sample: "Muestra:",
        "default-split-delay-type": "Tipo de retraso de división predeterminado",
        "default-time-mins-col": "Tiempo predeterminado (min)",
        "weight-t": "Peso (t)",
        "weight-kg": "Peso (kg)",
        "error-loading-actuals-definitions": "Error al cargar las definiciones de valores reales:",
        "term-imported": "{term} importado"
    },
    "tenant-change": {
        "select-org-mine": "Seleccionar organización/mina",
        "select-your-organisation-mine": "Seleccione su organización/mina"
    },
    terms: {
        search: "Buscar",
        "show-as": "Mostrar como",
        "show-as-plural": "Mostrar como, plural"
    },
    "trigger-action-response-plans": {
        department: "Departamento",
        description: "Descripción",
        "display-order": "Orden de visualización",
        order: "Orden",
        "generate-3-status-tarp": "Generar TARP de 3 estados",
        "generate-5-status-tarp": "Generar TARP de 5 estados",
        "task-colour": "Color de tarea"
    },
    "update-location-status-dialog": {
        status: "Estado",
        stope: "Cámara"
    },
    "update-tarp-status-dialog": {
        status: "Estado",
        stope: "Cámara",
        loader: "Cuadro de diálogo de actualización de estado de TARP",
        "confirm-set-existing-value": "Está estableciendo el estado en su valor existente. ¿Está seguro?"
    },
    "user-departments-dialog": {
        "select-departments": "Seleccionar departamentos"
    },
    users: {
        search: "Buscar",
        "mdi-shield-check": "mdi-shield_check",
        "user-admin": "Administración de usuarios",
        "confirm-delete": "Confirmar ELIMINACIÓN",
        "confirm-deactivate": "Confirmar desactivación"
    },
    "week-equipment": {
        "start-at": "Comenzar a las",
        "weekly-service": "Servicio semanal",
        "minor-service": "Servicio menor",
        "major-service": "Servicio mayor",
        unserviceable: "Inservible",
        "idle-unavailable-this-week": "Inactivo/No disponible esta semana",
        services: "Servicios",
        "ends-at": "Termina a las",
        "must-be-greater-than-start": "Debe ser mayor que el inicio"
    },
    "week-resourcing": {
        "crew-this-week": "Personal de esta semana",
        "default-crew": "Personal predeterminado",
        available: "Disponible",
        "leave-in-week": "Ausencia en la semana",
        "overtime-in-week": "Horas extra en la semana",
        "add-staff": "+ Añadir personal",
        unavailable: "No disponible",
        "overtime-available": "Horas extra disponibles",
        leave: "Ausencia",
        overtime: "Horas extra",
        "successfully-assigned-staff-to-crew": "Personal asignado al equipo correctamente",
        "unable-to-assign-staff-to-crew": "No se pudo asignar personal al equipo",
        "hide-unassigned": "Ocultar no asignados",
        "show-unassigned": "Mostrar no asignados"
    },
    weekly: {
        "add-name": "Agregar {name}",
        "remove-name": "Eliminar {name}",
        "no-locations-can-be-removed": "No se puede eliminar ninguna {term}",
        "unable-to-find-target-row": "No se pudo encontrar la fila de destino para {name} ({id})",
        "task-type-not-found": "No se encontró el tipo de tarea con id {id}.",
        "unknown-action": "Acción desconocida: {action}",
        "collapse-cycles": "Contraer ciclos",
        "export-adhoc-tasks": "Exportar tareas ad hoc",
        "planning-for-this-week-has-not-started": "La planificación de esta semana no ha comenzado",
        "import-plan": "Importar plan",
        "export-plan": "Exportar plan",
        "copy-allocations-to-right": "Copiar asignaciones de {term} a la derecha",
        "export-assignments": "Exportar asignaciones de {term}",
        "week-plan": "Plan semanal",
        "reset-plan": "Restablecer plan",
        "export-week-plan-to-csv": "Exportar plan semanal a CSV",
        "weekly-board": "Tablero semanal",
        "change-shift-summary-row": "Cambiar fila de resumen del turno",
        "start-planning": "Comenzar planificación",
        "weekly-board-export": "Exportación del tablero semanal",
        "week-warnings": "Advertencias de la semana",
        "editing-historic-cycles": "¡Actualmente está editando ciclos históricos!",
        "shift-info": "Información del turno",
        "crew-information": "Información del personal",
        "reset-week-plan": "Restablecer plan semanal",
        "confirm-reset-week-plan": "¿Está seguro de que desea restablecer el plan semanal?",
        "reset-week-plan-warning": "Al hacerlo se eliminarán todas las tareas que comiencen durante esta semana.",
        "promoting-fire-task-to-stope": "Promoviendo tarea de voladura a caserón.",
        "filtering-locations-warning": "Está filtrando ubicaciones sin actividad y es posible que no vea la nueva ubicación.",
        "failed-export-week-plan": "No se pudo exportar el plan semanal.",
        "delete-name": "Eliminar {name}",
        "confirm-delete-task": "¿Está seguro de que desea eliminar esta tarea?",
        "week-targets-generated": "Objetivos de la semana generados"
    },
    "daily-report": {
        "total-count": "Total: {count}",
        "error-loading-daily-report": "Error al cargar el informe diario: {error}",
        "error-generating-daily-report": "Error al generar el informe diario: {error}",
        "error-regenerating-daily-report": "Error al regenerar el informe diario: {error}",
        "error-saving-daily-report": "Error al guardar el informe diario: {error}",
        "error-marking-approved": "Error al marcar el informe diario como aprobado: {error}",
        "error-marking-not-approved": "Error al marcar el informe diario como no aprobado: {error}",
        "daily-report": "Informe diario",
        "time-of-blast": "Hora de la voladura",
        "pic-safe": "PIC seguro",
        equip: "Equipo",
        "first-work-time": "Hora del primer trabajo",
        activity: "Actividad",
        location: "Ubicación",
        comments: "Comentarios",
        "report-approved-for-use": "Informe aprobado para su uso.",
        "enter-edit-mode": "Entrar en modo de edición",
        "save-and-exit": "Guardar y salir",
        "cancel-approval": "Cancelar aprobación",
        approve: "Aprobar",
        "no-daily-report-found": "No se encontró ningún informe diario para esta fecha.",
        "generate-daily-report": "Generar informe diario",
        "daily-report-cannot-be-created-in-future": "El informe diario no se puede crear en el futuro.",
        "locations-needing-re-entry": "Ubicaciones que necesitan reingreso",
        "refresh-from-data-entry": "Actualizar desde la entrada de datos.",
        "to-alter-this-list": "Para modificar esta lista, vuelva atrás y cámbiela en la página de entrada de datos.",
        "measurement-date": "Fecha de medición",
        "to-date": "Fecha hasta",
        "hide-subcategories": "Ocultar subcategorías",
        "subcategories-available": "Subcategorías disponibles",
        reset: "Restablecer",
        "row-will-not-save-until-equipment-selected": "La fila no se guardará hasta que se seleccione un equipo.",
        "remove-first-work-activity": "Quitar primera actividad de trabajo.",
        "add-new-first-work-activity": "Añadir una nueva primera actividad de trabajo.",
        "add-new-comment": "Añadir un nuevo comentario.",
        remove: "Quitar.",
        "daily-report-generated-successfully": "Informe diario generado correctamente",
        "daily-report-regenerated-successfully": "Informe diario regenerado correctamente",
        "daily-report-saved-successfully": "Informe diario guardado correctamente",
        "confirm-mark-not-approved": "¿Está seguro de que desea marcar este informe diario como no aprobado?",
        "approve-report": "Aprobar informe",
        "confirm-mark-approved": "¿Está seguro de que desea marcar este informe diario como aprobado?",
        "still-able-to-make-changes": "Aún podrá realizar cambios después de hacerlo.",
        "daily-report-approved": "Informe diario aprobado",
        "daily-report-unapproved": "Informe diario no aprobado"
    },
    "equipment-downtime": {
        equipment: "Equipo",
        "downtime-code": "Código de inactividad",
        "duration-minutes": "Duración (minutos)",
        comments: "Comentarios",
        "add-equipment-downtime": "Añadir tiempo de inactividad del equipo",
        "no-data-available-in-the-table": "No hay datos disponibles en la tabla."
    },
    "key-physical-actuals": {
        "error-populating-actuals-from-shift-plan": "Error al rellenar los datos reales desde el plan de turno: {error}",
        cut: "Corte n.º",
        "metres-advanced": "Metros avanzados",
        "start-chainage-m": "Cadenamiento inicial (m)",
        "end-chainage-m": "Cadenamiento final (m)",
        "tonnes-fired": "Toneladas voladas",
        "measured-tonnes-fired": "Toneladas voladas medidas",
        "no-key-physicals-data-found": "No se encontraron datos de físicos clave.",
        "populate-data-for-shift": "Completar datos del turno",
        "add-metres-advanced": "Añadir metros avanzados",
        "add-tonnes-fired": "Añadir toneladas disparadas",
        note: "Nota:",
        "metres-advanced-readjust-warning": "Los cambios en los metros avanzados (agregar / actualizar / eliminar) podrían provocar que los números de corte y los inicios de cadenamiento se reajusten posteriormente.",
        "cut-number": "Corte n.º",
        "start-chainage": "Cadenamiento inicial",
        "single-box-metres-advanced": "Metros avanzados de caja única",
        "end-chainage": "Cadenamiento final",
        "planned-metres-tooltip": "Los metros avanzados planificados del plan semanal. Ingrese un valor para sustituir.",
        "updated-metres-tooltip": "Metros avanzados actualizados. Quite este valor para revertir al valor del plan semanal.",
        "averaged-value-tooltip": "Valor promediado para este corte según la longitud topografiada más relevante.",
        "actuals-populated-from-shift-plan": "Valores reales completados a partir del plan de turno",
        "delete-cut": "Eliminar corte",
        "are-you-sure-delete-cut": "¿Está seguro de que desea eliminar este corte? A cualquier valor real asociado con este número de corte se le quitará la asociación."
    },
    "admin-home": {
        administration: "Administración"
    },
    "navigation-drawer": {
        security: "Seguridad",
        sandpit: "Entorno de pruebas",
        "clear-local-tenant-cache": "Borrar caché local del inquilino",
        configuration: "Configuración",
        "communications-configuration": "Configuración de comunicaciones",
        reporting: "Informes",
        "local-tenant-information-cleared": "Información local del inquilino borrada."
    },
    "admin-sandpit-item-name": {
        sp: "(SP)"
    },
    "admin-sandpit-visibility-selector": {
        "sandpit-visibility": "Visibilidad del entorno de pruebas"
    },
    "admin-equipment": {
        "equipment": {
            "charger": "Camión cargador",
            "service-crew": "Cuadrilla de servicio",
            "flatbed-truck": "Camión de plataforma",
            "personnel-carrier": "Vehículo de transporte de personal",
            "water-truck": "Camión cisterna de agua",
            "tanker-truck": "Camión cisterna",
            "explosives-truck": "Camión de explosivos",
            "forklift": "Montacargas",
            "drill-rig-surface": "Equipo de perforación (superficie)",
            "crane-franna": "Grúa Franna",
            "service-truck": "Camión de servicio",
            "storeperson": "Encargado de almacén",
            "dump-truck-surface": "Camión volquete (superficie)",
            "fuel-truck": "Camión de combustible",
            "crane-mobile": "Grúa móvil",
            "digger-backhoe": "Retroexcavadora",
            "digger-front-end": "Cargador frontal",
            "dozer": "Topadora",
            "dragline": "Dragalina",
            "prime-mover-tipper-trailer": "Tractocamión con remolque volquete",
            "electric-rope-shovel": "Pala eléctrica de cables",
            "cabolter": "Equipo empernador",
            "diamond-drill-rig": "Equipo de perforación diamantina",
            "lHD-loader": "Cargador LHD",
            "longhole-drill-rig": "Equipo de perforación de barrenos largos",
            "refuge-chamber": "Cámara de refugio",
            "scissor-lift": "Plataforma elevadora de tijera",
            "sprayer": "Pulverizador",
            "grader": "Motoniveladora",
            "charger-uphole": "Camión cargador (perforación ascendente)",
            "compaction-roller": "Rodillo compactador",
            "agitator-truck": "Camión agitador",
            "jumbo-drill-rig": "Jumbo de perforación",
            "integrated-toolcarrier": "Portaherramientas integrado",
            "dump-truck-underground": "Camión volquete (subterráneo)",
            "light-vehicle-tray": "Vehículo liviano (con caja)",
            "light-vehicle-wagon": "Vehículo liviano (rural)",
            "raisebore-rig": "Equipo de perforación de chimeneas",
            "spotter": "Señalero",
            "plant": "Maquinaria",
            "hydraulic-excavator": "Excavadora hidráulica"
        }
    },
    "shift-schedule-editor": {
        "shift-name": "Nombre del turno",
        "duration-minutes": "Duración (minutos)",
        "shift-schedule": "Horario de turnos",
        "each-day-must-have-shifts-that-total-exactly-1440-minutes-24-hours": "Cada día debe tener turnos que sumen exactamente 1440 minutos (24 horas).",
        "add-shift": "Añadir turno",
        "shift-schedule-saved": "Horario de turnos guardado",
        "failed-to-save-shift-schedule": "No se pudo guardar el horario de turnos"
    },
    "stope-blast-packets-list": {
        "new-term": "Nuevo {term}",
        "delete-term": "Eliminar {term}",
        "edit-term": "Editar {term}",
        "move-term": "Mover {term}",
        loading: "Cargando {term}",
        "last-updated": "Última actualización"
    },
    "task-debug": {
        "cycle-id": "ID de ciclo",
        "task-id": "ID de tarea",
        correlation: "Correlación",
        "auto-split": "División automática",
        "manual-split": "División manual",
        "different-from-config": "Diferente de la configuración",
        "is-locked-in-past": "Está bloqueado en el pasado"
    },
    "task-details-badge": {
        cut: "Corte n.º:",
        quantity: "Cantidad:",
        chainage: "Cadenamiento:",
        "not-set": "Sin establecer"
    },
    "captain-board": {
        "shift-interactions-date": "Interacciones de turno {date}",
        "split-over-eos": "(dividido en el fin de turno)",
        legend: "Leyenda",
        "shift-interactions": "Interacciones de turno"
    },
    "interactions-side-drawer": {
        meetings: "Reuniones",
        "shift-interactions": "Interacciones de turno",
        "filters-and-groups": "Filtros y grupos",
        filters: "Filtros",
        grouping: "Agrupación",
        columns: "Columnas",
        groupings: "Agrupaciones",
        conflicts: "Conflictos",
        "interactions-side-drawer": "Panel lateral de interacciones",
        "shift-interactions-meeting": "Reunión de interacciones de turno"
    },
    "stope-rings-list": {
        "new-term": "Nuevo {term}",
        reorder: "Reordenar",
        loading: "Cargando {term}",
        "total-drill-distance": "Distancia total de perforación",
        "total-charge": "Carga total",
        "extraction-amount": "Cantidad de extracción",
        "ring-order": "Orden del anillo",
        "last-updated": "Última actualización"
    },
    "development-tracker-board": {
        "latest-cut": "Último: {cutNumber}",
        "start-cut": "Inicio: {cutNumber}",
        "more-info": "más información",
        "calculated-from-latest-chainage": "Calculado a partir del último cadenamiento y los metros avanzados ingresados.",
        "cut-number": "CORTE N.º",
        "last-survey": "ÚLTIMA TOPOGRAFÍA",
        "chainage-calc": "CADENAMIENTO (Calc)"
    },
    "import-blast-packets": {
        validate: "Validar",
        "there-are-one-or-more-issues-with-the-blast-packet-design-please-resolve-before-continuing": "Hay uno o más problemas con el diseño del paquete de voladura. Por favor, resuélvalos antes de continuar",
        "successfully-imported-blast-packets": "Paquetes de voladura importados correctamente",
        "there-may-have-been-issues-with-your-import": "Es posible que haya habido problemas con su importación"
    },
    "import-location-rings": {
        validate: "Validar",
        "there-are-one-or-more-issues-with-the-ring-design-please-resolve-before-continuing": "Hay uno o más problemas con el diseño del anillo. Por favor, resuélvalos antes de continuar",
        "successfully-import-rings": "Anillos importados correctamente",
        "import-issues": "Es posible que haya habido problemas con su importación",
        "ring-order": "Orden del anillo",
        "hole-name": "Nombre del barreno",
        "drill-distance": "Distancia de perforación",
        "charge-distance": "Distancia de carga"
    },
    "location-tracker-side-drawer": {
        "archived-term": "{term} archivadas",
        rings: "Anillos",
        "blast-packets": "Paquetes de voladura",
        physicals: "Físicos",
        "column-options": "Opciones de columna",
        information: "Información",
        planning: "Planificación",
        "shift-sidedrawer": "Panel lateral de turno",
        "location-filters": "Filtros de ubicación",
        clear: "Limpiar",
        "show-archived": "Mostrar archivados"
    },
    "slc-tracker-board": {
        "location-ring-assigned-to-blast-packet": "El anillo de ubicación {name} está asignado a un paquete de voladura.",
        "blast-packet-has-work": "El paquete de voladura {name} tiene trabajo planificado y/o registrado.",
        "bogging-priority": "Prioridad de extracción",
        "ring-duration": "DURACIÓN DEL ANILLO (días desde la última voladura)",
        "avg-ring-tonnes-per-day": "PROM. TONELADAS DE ANILLO/DÍA",
        "current-status": "ESTADO ACTUAL",
        "based-on-last-entered-actuals-or-fire-task": "Según los últimos valores reales ingresados o la tarea de voladura",
        "last-ring-drilled": "ÚLTIMO ANILLO PERFORADO",
        "last-ring-charged": "ÚLTIMO ANILLO CARGADO",
        "last-ring-fired": "ÚLTIMO ANILLO VOLADO",
        "days-charged": "DÍAS CARGADO",
        "next-ring-to-fire": "PRÓXIMO ANILLO A VOLAR",
        "recovery-ring-detail": "DETALLE DEL ANILLO DE RECUPERACIÓN",
        "bogged-to-date": "EXTRAÍDO HASTA LA FECHA (t)",
        "still-to-bog": "AÚN POR EXTRAER (t)",
        "extraction-target": "OBJETIVO DE EXTRACCIÓN (t)",
        "delete-location-ring": "Eliminar anillo de ubicación",
        "checking-status": "Comprobando estado...",
        "are-you-sure-delete-location-ring": "¿Está seguro de que desea eliminar este anillo de ubicación?",
        "deleting-may-lead-to-lost-work": "Eliminarlo puede provocar la pérdida de trabajo o la eliminación del paquete de voladura asociado.",
        "confirm-type-name-location-ring": "Para confirmar que desea eliminarlo, escriba el nombre del anillo de ubicación a continuación.",
        "warning-action-cannot-be-undone": "Advertencia: Esta acción no se puede deshacer.",
        "delete-term": "Eliminar {term}",
        "are-you-sure-delete-blast-packet": "¿Está seguro de que desea eliminar este paquete de voladura?",
        "confirm-type-name-blast-packet": "Para confirmar que desea eliminarlo junto con cualquier trabajo asociado, escriba el nombre del paquete de voladura a continuación.",
        "failed-to-update-blast-packet": "No se pudo actualizar el paquete de voladura"
    },
    "stope-levels-list": {
        "stope-term": "{term} de realce",
        "location-has-work-planned": "La ubicación {name} tiene trabajo planificado.",
        "add-drawpoint": "Añadir punto de extracción",
        "delete-location": "Eliminar ubicación",
        "checking-status": "Comprobando estado...",
        "are-you-sure-delete-stope-location": "¿Está seguro de que desea eliminar esta ubicación de cámara?",
        "confirm-type-location-name": "Para confirmar que desea eliminarla junto con cualquier trabajo asociado, escriba el nombre de la ubicación a continuación.",
        "warning-cannot-be-undone": "Advertencia: Esta acción no se puede deshacer."
    },
    "stope-tracker-board": {
        "more-info": "más información",
        "bogging-priority": "Prioridad de extracción",
        "calculated-tonnes-tooltip": "Calculado a partir de las últimas toneladas topografiadas en la cámara, las toneladas voladas ingresadas y las cifras de extracción ingresadas.",
        "tonnes-in-stope": "Toneladas en la cámara",
        "avg-tonnes-per-day": "PROM. TONELADAS/DÍA",
        "bogged-to-date": "EXTRAÍDO HASTA LA FECHA (t)",
        "survey-tonnes": "TONELADAS TOPOGRAFIADAS",
        "tonnes-avail": "TONELADAS DISP."
    },
    "production-front-viewer": {
        "ring-statuses": "Estados de anillos",
        "remove-from-viewer": "Quitar del visor",
        "add-to-viewer": "Añadir al visor",
        "lashing-lashed": "Limpieza / Limpiado",
        fired: "Volado",
        "charging-charged": "Cargando / Cargado",
        "drilling-drilled": "Perforando / Perforado",
        "not-drilled": "Sin perforar",
        "ring-names": "Nombres de anillos",
        none: "Ninguno",
        highlight: "Resaltar",
        all: "Todos",
        choose: "Elegir",
        "front-progress": "Progreso del frente",
        drilling: "Perforación",
        "hide-all-ring-names": "Ocultar todos los nombres de {term}",
        "show-last-drilled-next-to-fire-ring-names": "Mostrar los nombres de {term} del último perforado y el próximo a volar",
        "show-all-ring-names": "Mostrar todos los nombres de {term}",
        "planned-work": "Trabajo planificado",
        "work-planned": "Trabajo planificado",
        "charge-sleep-expiry": "Caducidad de carga en reposo",
        "visible-level": "{term} visibles",
        "show-additional-levels": "Mostrar {term} adicionales",
        "planning-view": "Vista de planificación",
        "no-planning-overlay": "Sin superposición de planificación",
        "show-rings-to-consider-for-progressing-front": "Mostrar {term} a considerar para avanzar el frente",
        "show-valid-rings-to-drill": "Mostrar {term} válidos para perforar",
        "start-planning": "Comenzar planificación"
    },
    "audit-event-viewer": {
        "failed-to-load-data": "No se pudieron cargar los datos",
        "hide-detail": "Ocultar detalle",
        "show-detail": "Mostrar detalle",
        "audit-event-viewer": "Visor de eventos de auditoría",
        "no-audit-events": "Sin eventos de auditoría",
        "load-more": "Cargar más"
    },
    "change-conflict": {
        "a-change-has-conflicted-with-another-users-changes": "Un cambio ha entrado en conflicto con los cambios de otro usuario.",
        "location-name": "Nombre de la ubicación",
        "updated-by": "Actualizado por",
        "change-conflict": "Conflicto de cambios",
        "refresh-data": "Actualizar datos"
    },
    "communications-equipment-task-card": {
        "task-comments": "Comentarios de la tarea"
    },
    "generate-week-key-physical-targets-dialog": {
        "generate-week-targets": "Generar objetivos de la semana",
        "checking-if-targets-already-exist-for-the-week": "Comprobando si ya existen objetivos para la semana...",
        "targets-already-exist-for-the-week": "Ya existen objetivos para la semana.",
        "do-you-want-to-replace-the-existing-targets": "¿Desea reemplazar los objetivos existentes?",
        "generate-targets-for-the-week": "¿Generar objetivos para la semana?",
        "there-are-currently-no-existing-targets-for-this-week": "Actualmente no hay objetivos existentes para esta semana.",
        generate: "Generar"
    },
    "main-menu": {
        "version": "Versión {version}",
        "change-org-mine": "Cambiar organización/mina",
        administration: "Administración",
        help: "Ayuda",
        "main-menu": "Menú principal",
        logout: "Cerrar sesión"
    },
    "navigation-menu": {
        "navigation-menu": "Menú de navegación",
        "geomoby-logo": "Logo de GeoMoby",
        "shift-board": "Tablero de turno",
        "data-entry": "Entrada de datos",
        "resource-chart": "Gráfico de recursos",
        "governance-analytics": "Análisis de gobernanza",
        "daily-analytics": "Análisis diario",
        "crew-magnet-board": "Tablero magnético de personal",
        "equipment-magnet-board": "Tablero magnético de equipos",
        "shift-supervisor-report": "Informe del supervisor de turno",
        "week-board": "Tablero semanal",
        "slc-tracker-board": "Tablero de seguimiento SLC",
        "stope-tracker-board": "Tablero de seguimiento de cámaras",
        "development-tracker-board": "Tablero de seguimiento de desarrollo",
        "production-front-viewer": "Visor del frente de producción",
        "geomoby-mine-map": "Mapa de mina GeoMoby",
        "reporting-targets": "Objetivos de reporte",
        "daily-report": "Informe diario",
        "resources": "Recursos",
        "communications": "Comunicaciones"
    },
    "no-permission-button": {
        "no-permission": "Sin permiso",
        "insufficient-permission": "permiso insuficiente para realizar esta acción"
    },
    "print-window": {
        "problems-previewing": "¿Problemas con la vista previa?",
        download: "Descargar",
        refresh: "Actualizar",
        "print-window": "Ventana de impresión"
    },
    "shift-owner-menu": {
        "shift-owner": "Responsable del turno",
        "publish-shift": "Publicar turno",
        handover: "Entrega",
        assign: "Asignar",
        "take-ownership": "Tomar propiedad",
        "publish-shift-as-a-snapshot": "Publicar turno como instantánea",
        "start-handover-meeting": "Iniciar una reunión de entrega con otro usuario",
        "assign-shift-ownership": "Asignar la propiedad del turno a otro usuario",
        "take-shift-ownership": "Tomar propiedad del turno",
        "confirm-publish-shift": "¿Está seguro de que desea publicar este turno y crear una línea base de publicación?",
        "no-shift-owner": "Sin responsable del turno"
    },
    "terms-and-conditions": {
        "end-user-license-agreement": "Acuerdo de licencia de usuario final",
        "please-read-through-and-accept-the-end-user-license-agreement-to-continue": "Por favor, lea y acepte el acuerdo de licencia de usuario final para continuar.",
        "cancel-and-logout": "Cancelar y cerrar sesión",
        agree: "Aceptar",
        "accepted-terms-and-conditions": "Términos y condiciones aceptados"
    },
    "to-do-actions-menu": {
        "add-task": "Añadir tarea",
        "no-tasks": "Sin tareas",
        "cannot-add-tasks-whilst-offline": "No se pueden añadir tareas sin conexión."
    },
    "version-check": {
        "your-version-of-ordo-is-out-of-date-please-reload-now": "Su versión de Ordo está desactualizada. Por favor, recargue ahora.",
        "new-version": "Nueva versión:",
        "your-version": ", su versión:",
        "ordo-updated": "Ordo actualizado",
        reload: "Recargar"
    },
    priority: {
        priority: "Prioridad",
        completion: "Finalización",
        "priority-prefix": "Prioridad ",
        "other-prefix": "Otro "
    },
    "communications-page": {
        priorities: "Prioridades",
        "priority-1": "Prioridad 1",
        "priority-2": "Prioridad 2",
        "priority-3": "Prioridad 3",
        "equipment-in-workshop": "Equipos en taller",
        "equipment-to-workshop-by-eos": "Equipos al taller para el fin de turno",
        "weekly-comms": "Comunicaciones semanales",
        "shift-comms": "Comunicaciones de turno",
        "equipment-and-tasks": "Equipos y tareas"
    },
    "add-any-staff": {
        "temporarily-add-staff-from-another-crew-into-this-shift": "Añadir temporalmente personal de otro equipo a este turno"
    },
    "add-any-staff-to-crew": {
        "permanently-move-staff-from-another-crew-into-this-crew": "Mover permanentemente personal de otro equipo a este equipo",
        "add-staff-to-crew-and-week": "Añadir personal al personal de turno y a la semana"
    },
    "board-warnings-dialog": {
        "no-warnings": "Sin advertencias"
    },
    "bring-forward-dialog": {
        "there-are-no-planned-tasks-to-bring-forward": "No hay tareas planificadas para adelantar",
        "this-shift-is-already-fully-planned": "Este turno ya está completamente planificado",
        "bring-forward": "Adelantar",
        "will-move-from": "se moverá desde"
    },
    "previous-shift-dialog": {
        "no-tasks": "Sin tareas",
        "did-not-fire": "No se disparó"
    },
    "board-filter-and-sort-drawer-section": {
        clear: "Limpiar",
        "show-empty": "Mostrar {term} vacíos"
    },
    "equipment-drawer": {
        "finish-assigning": "Termine de asignar {name} primero.",
        equipment: "Equipos",
        "unresourced-tasks": "Tareas sin recursos",
        "hide-unavailable": "Ocultar {term} no disponibles",
        "highlight-unresourced-tasks": "Resaltar tareas sin recursos"
    },
    "event-logs": {
        "event-log": "Registro de eventos",
        "event-logs": "Registros de eventos"
    },
    "shift-side-drawer": {
        baselines: "Líneas base",
        "event-logs": "Registros de eventos",
        meetings: "Reuniones",
        "shift-handover-meeting": "Reunión de entrega de turno",
        "shift-handover": "Entrega de turno",
        "shift-deployment-meeting": "Reunión de despliegue de turno",
        "shift-deployment": "Despliegue de turno",
        "filters-and-groups": "Filtros y grupos",
        filters: "Filtros",
        grouping: "Agrupación",
        columns: "Columnas",
        groupings: "Agrupaciones",
        "shift-sidedrawer": "Panel lateral de turno"
    },
    "equipment-availability-bar": {
        unavailable: "No disponible"
    },
    "resource-chart": {
        "primary-equipment-utilisation": "Porcentaje de utilización de {term} primario en este turno",
        "secondary-equipment-utilisation": "Porcentaje de utilización de {term} secundario en este turno",
        "support-equipment-utilisation": "Porcentaje de utilización de {term} de apoyo en este turno",
        "resources-chart": "Gráfico de recursos",
        "resource-utilisation": "Utilización de recursos",
        "percentage-utilisation-of-crew-members-in-shift": "Porcentaje de utilización de los miembros del personal en este turno"
    },
    "location-tasks-card": {
        "no-resource-tasks": "No hay tareas de {resource}. Asigne directamente a las tareas en su lugar.",
        "assign-to-all-resource-tasks": "Asignar a todas las tareas de {resource}.",
        no: "Sin {term}",
        commentary: "Comentario",
        "add-hazard": "Añadir peligro",
        "assign-to-all-term": "Asignar a todos los {term}",
        "cannot-auto-assign-based-on-role": "No se puede asignar automáticamente según la función. En su lugar, asigne directamente a {term}."
    },
    baselines: {
        "hide-baseline": "Ocultar línea base",
        baselines: "Líneas base",
        "enter-actuals": "Ingresar datos reales"
    },
    "supervisor-printer": {
        print: "Imprimir",
        "print-supervisor-report": "Imprimir informe del supervisor"
    },
    "condition-monitoring": {
        "condition-monitoring": "Monitoreo de condición",
        location: "Ubicación",
        time: "Hora",
        activity: "Actividad",
        action: "Acción"
    },
    "delays-and-down-times": {
        "delays-and-downtime": "Retrasos e inactividad",
        issue: "Problema",
        hours: "Horas"
    },
    "miscellaneous-tasks": {
        "miscellaneous-tasks": "Tareas varias",
        location: "Ubicación",
        task: "Tarea",
        physicals: "Físicos",
        unit: "Unidad",
        comments: "Comentarios"
    },
    "planned-equipment": {
        operator: "Operador",
        level: "Nivel",
        location: "Ubicación",
        task: "Tarea",
        details: "Detalles"
    },
    "shift-manning": {
        "shift-manning": "Dotación del turno",
        "safe-stops": "Paradas seguras",
        hrs: "Hrs",
        total: "TOTAL:"
    },
    "supervisor-equipment-downtime-tab": {
        "add-term-downtime": "Agregar tiempo de inactividad de {term}",
        downtime: "Inactividad",
        "add-downtime": "Añadir inactividad de {term}",
        select: "Seleccionar {term}",
        "select-reason": "Seleccionar motivo",
        "minutes-downtime": "Minutos de inactividad",
        comment: "Comentario",
        "add-equipment-downtime": "Añadir {term}",
        "must-be-at-least-15-minutes": "Debe ser al menos 15 minutos"
    },
    "supervisor-staff-and-equipment-tab": {
        "no-more-than-hours": "No más de {hours} horas.",
        "safe-stops": "Paradas seguras",
        "shift-manning": "Dotación del turno",
        prestart: "PreInicio",
        hazards: "Peligros",
        hours: "Horas",
        "hours-worked": "Horas trabajadas"
    },
    "variance-to-plan": {
        "variance-to-plan": "Variación (respecto al plan)",
        area: "Área",
        priority: "Prioridad",
        comments: "Comentarios",
        unavailable: "No disponible"
    },
    "in-place-task-quantity-update": {
        quantity: "Cantidad:",
        "chainage-label": "Cadenamiento:",
        start: "Inicio",
        end: "Fin",
        confirm: "Confirmar"
    },
    "key-physical-targets": {
        "week-level-targets": "Objetivos a nivel de semana: Semana que comienza {weekStart}",
        "key-physical-targets": "Objetivos físicos clave",
        "project-level-targets": "Objetivos a nivel de proyecto",
        "import-targets": "Importar objetivos",
        "key-physical-targets-term": "Objetivos de {term}",
        "month-level-targets": "Objetivos a nivel de mes",
        "no-weekly-targets": "No hay objetivos semanales. ¿Desea generarlos?",
        "generate-targets": "Generar objetivos",
        "metres-advanced": "Metros avanzados",
        "tonnes-bogged": "Toneladas cargadas",
        "tonnes-fired": "Toneladas voladas"
    },
    "manual-planning-drawer": {
        planning: "Planificación",
        "finish-planning-current-task": "Finalizar la planificación de la tarea actual...",
        loading: "Cargando...",
        "choose-planning-type": "Elegir tipo de planificación",
        "no-cycles": "Sin ciclos",
        "no-tasks": "Sin tareas"
    },
    "planning-drawer": {
        "remove-name": "Eliminar {name}",
        planning: "Planificación",
        "show-suggested-tasks": "Mostrar tareas sugeridas",
        "show-all-tasks": "Mostrar todas las tareas",
        "show-all-blast-packet-tasks": "Mostrar todas las tareas del paquete de voladura",
        "finish-planning-current-task": "Finalizar la planificación de la tarea actual...",
        loading: "Cargando...",
        "only-show-suggested-ring-tasks": "Mostrar solo las tareas de anillo sugeridas",
        "show-all-ring-tasks": "Mostrar todas las tareas de anillo",
        "only-show-suggested-blast-packet-tasks": "Mostrar solo las tareas de paquete de voladura sugeridas (oculta las tareas si no todos los anillos están cargados)",
        "no-rings": "Sin anillos"
    },
    screen: {
        bog: "Extraer",
        drill: "Perforar"
    },
    account: {
        "back-to-board": "Volver al tablero",
        "my-account": "Mi cuenta",
        "change-password": "Cambiar contraseña",
        "current-password": "Contraseña actual",
        "new-password": "Nueva contraseña",
        "new-password-again": "Nueva contraseña de nuevo",
        change: "Cambiar"
    },
    admin: {
        "back-to-board": "Volver al tablero",
        "super-admin": "Superadministrador",
        "fix-users": "CORREGIR USUARIOS"
    },
    callback: {
        "logging-you-in": "Iniciando sesión...",
        "logging-you-in-error": "Ocurrió un error al iniciar sesión, por favor inténtelo de nuevo"
    },
    error404: {
        "page-not-found": "Página no encontrada"
    },
    home: {
        begin: "Comenzar",
        logout: "Cerrar sesión",
        login: "Iniciar sesión"
    },
    login: {
        "taking-you-to-the-login-screen": "Llevándote a la pantalla de inicio de sesión..."
    },
    logout: {
        "logging-you-out": "Cerrando sesión..."
    },
    "import-reporting-months-dialog": {
        line: "Línea {number}",
        "month-template": "Mes {month}",
        "import-reporting-months": "Importar meses de reporte",
        validate: "Validar",
        "import-file-details": "Detalles del archivo de importación",
        "to-aid-in-importing": "Para ayudar con la importación de los meses de reporte, descargue la plantilla.",
        "each-line-corresponds": "Cada línea del archivo de importación corresponde a un único mes de reporte.",
        year: "Año",
        "year-description": ": El año del mes de reporte.",
        month: "Mes",
        "month-description": ": El número del mes (1-12).",
        "start-date": "Fecha de inicio",
        "start-date-description": ": La fecha de inicio del mes de reporte en formato YYYY-MM-DD.",
        "end-date": "Fecha de fin",
        "end-date-description": ": La fecha de fin del mes de reporte en formato YYYY-MM-DD.",
        "import-issues": "Hay uno o más problemas con su importación. Por favor, resuélvalos antes de continuar",
        "import-warning": "Puede que haya habido problemas con su importación",
        "unknown-error": "Error desconocido"
    },
    "production-front-overlay-card": {
        "overlay-name": "Nombre de la superposición"
    },
    staff: {
        "active-term": "{term} activo",
        "archived-term": "{term} archivado",
        "cannot-import-no-staff-roles-available": "No se puede importar: No hay funciones de personal disponibles.",
        "archiving-removes-from-crew": "Archivar a un miembro del personal lo elimina de su personal de turno, pero no afectará las asignaciones históricas.",
        "archive-staff-member": "¿Archivar miembro del personal?",
        "restoring-not-add-to-crew": "Restaurar a un miembro del personal no lo volverá a agregar a su personal de turno.",
        "restore-archived-staff-member": "¿Restaurar miembro del personal archivado?"
    },
    "stope-tarp-history-dialog": {
        "changed-at": "Cambiado el",
        "changed-by": "Cambiado por",
        comments: "Comentarios"
    },
    "report-viewer": {
        "refreshes-exhausted": "Actualizaciones agotadas. Las actualizaciones se restablecerán: {resetAt}",
        "last-refreshed": "Última actualización {dateTime}",
        "refreshes-will-reset-at": "Las actualizaciones se restablecerán a las {dateTime}",
        refresh: "Actualizar",
        "no-permission-to-refresh-reports": "No tiene permiso para actualizar los informes.",
        "last-refresh-running-longer-than-expected": "La última actualización está tardando más de lo esperado...",
        "refreshes-nearing-limit": "Actualizaciones cerca del límite",
        "fewer-than-2-refreshes-remaining": "Le quedan 2 o menos actualizaciones.",
        "are-you-sure-wish-to-refresh": "¿Está seguro de que desea actualizar?",
        "refresh-queued": "Actualización en cola"
    },
    "offline-button": {
        "no-connection": "Sin conexión",
        "internet-connection-not-active": "Su conexión a Internet no está activa actualmente. Si esto es solo temporal, espere un momento y esta página volverá a estar accesible."
    },
    "shift-inspections": {
        attachments: "Adjuntos",
        "view-attachments": "Ver adjuntos",
        "reported-by": "Reportado por",
        "reported-at": "Reportado el"
    },
    "copy-shift-crew-assignments-dialog": {
        "crews": "Cuadrillas: {crews}",
        "this-will-result-in-the-following-changes": "Esto resultará en los siguientes cambios:",
        copy: "Copiar"
    },
    "import-week-plan-dialog": {
        "manual-cycle-name": "Ciclo manual - {name}",
        "adhoc-cycle-name": "Ciclo ad hoc - {name}",
        "adhoc-task-name": "Tarea ad hoc- {name}",
        line: "Línea {number}",
        "import-plan": "Importar plan",
        validate: "Validar",
        "import-file-details": "Detalles del archivo de importación",
        "help-intro": "Para ayudar a importar un plan, descargue la plantilla.",
        "help-each-line": "Cada línea del archivo de importación corresponde a una sola tarea o a un ciclo de trabajo completo.",
        "col-location": "Ubicación",
        "col-location-desc": ": Nombre de la ubicación en la que planificar el trabajo.",
        "col-priority": "Prioridad",
        "col-priority-desc": ": Prioridad de planificación a asignar a esta ubicación en esta semana. Debe ser un número entero no negativo.",
        "col-target-cycles": "Ciclos objetivo (opcional)",
        "col-target-cycles-desc": ": El número de ciclos que se pretende completar en esta semana. Debe ser un número entero no negativo.",
        "col-target-start-shift": "Turno de inicio objetivo",
        "col-target-start-shift-desc": ": Nombre del turno en el que debe comenzar el trabajo. Debe tener el formato \"[Día de la semana] [Nombre del turno]\". Ej. \"Lun Noche\"",
        "col-start-time": "Hora de inicio (opcional)",
        "col-start-time-desc-1": ": Hora del día en la que debe comenzar el trabajo. Debe estar dentro del",
        "col-start-time-desc-2": "y estar en formato de 24 horas. Si se omite, se utiliza el inicio del turno de forma predeterminada.",
        "col-import-type": "Tipo de importación",
        "col-import-type-desc-1": ": El tipo de trabajo que se importa. Debe ser \"Task\", \"Cycle\" o \"AdHoc\". \"Task\" se utiliza para importar tareas individuales o para construir ciclos de trabajo manuales (junto con el",
        "col-import-type-desc-2": ". \"Cycle\" se utiliza para importar ciclos de trabajo predefinidos. \"AdHoc\" se utiliza para importar tareas ad-hoc como Servicios o Mantenimiento.",
        "col-cycle-id": "ID de ciclo",
        "col-cycle-name": "Nombre del ciclo",
        and: "y",
        "col-duration": "Duración (obligatorio para importaciones AdHoc y Task)",
        "col-duration-desc": ": La duración, en incrementos de 15 minutos, del trabajo planificado. Se redondeará hacia abajo si no está en incrementos de 15 minutos.",
        "col-task-name": "Nombre de la tarea (obligatorio para importaciones AdHoc y Task)",
        "col-task-name-desc": ": El nombre del tipo de tarea predefinido al que pertenece el trabajo.",
        "col-cycle-name-full": "Nombre del ciclo (obligatorio para importaciones Cycle y AdHoc Cycle)",
        "col-cycle-name-desc": ": Para importaciones Cycle, este es el nombre del ciclo de trabajo predefinido a planificar. También debe especificarse al planificar un ciclo manual (incluidos los ciclos AdHoc), en cuyo caso puede ser el nombre de un ciclo de trabajo predefinido con el que asociar el ciclo manual, o un nombre completamente nuevo. Debe tener 50 caracteres o menos.",
        "col-cycle-name-abbr": "Abreviatura del nombre del ciclo (opcional)",
        "col-cycle-name-abbr-desc": ": Al planificar ciclos de trabajo manuales, proporciona una abreviatura del nombre del ciclo para mostrar en espacios pequeños. Debe tener 20 caracteres o menos.",
        "col-cycle-id-optional": "ID de ciclo (opcional)",
        "col-cycle-id-desc": ": Se utiliza para agrupar importaciones Task dentro del archivo como un único ciclo manual. También puede utilizarse para agregar nuevas tareas a ciclos manuales existentes de la semana anterior.",
        "col-cycle-fg-colour": "Color de primer plano del ciclo (opcional)",
        "col-cycle-fg-colour-desc": ": Al especificar un ciclo manual (incluidos los ciclos AdHoc), especifica el color del texto del ciclo en la interfaz. Debe ser un color CSS válido.",
        "col-cycle-bg-colour": "Color de fondo del ciclo (opcional)",
        "col-cycle-bg-colour-desc": ": Al especificar un ciclo manual (incluidos los ciclos AdHoc), especifica el color del ciclo en la interfaz. Debe ser un color CSS válido.",
        "col-quantity": "Cantidad (obligatorio para tareas basadas en tasa)",
        "col-quantity-desc": ": Se utiliza para asignar una cantidad a una importación Task. Ej. \"Metros a perforar\".",
        "col-ring-name": "Nombre del anillo (opcional)",
        "col-ring-name-desc": ": Se utiliza para indicar que una tarea sirve para avanzar un anillo hasta el punto de voladura.",
        "col-blast-packet-name": "Nombre del paquete de voladura (opcional)",
        "col-blast-packet-name-desc": ": Se utiliza para indicar que una tarea sirve para volar o extraer un paquete de voladura.",
        "col-equipment-name": "Nombre del equipo (opcional)",
        "col-task-priority": "Prioridad de la tarea (opcional)",
        "col-task-priority-desc": ": Se utiliza con importaciones AdHoc para asignar una prioridad de tarea.",
        "col-location-name-override": "Sustitución del nombre de la ubicación (opcional)",
        "col-location-name-override-desc": ": Se utiliza con importaciones AdHoc para sustituir el nombre de la ubicación.",
        "col-task-name-override": "Sustitución del nombre de la tarea (opcional)",
        "col-task-name-override-desc": ": Se utiliza con importaciones AdHoc para sustituir el nombre de la tarea.",
        "col-description": "Descripción (opcional)",
        "col-description-desc": ": Se utiliza con importaciones AdHoc para proporcionar una descripción de la tarea.",
        "col-consumables": "Consumibles (opcional)",
        "col-consumables-desc": ": Se utiliza con importaciones AdHoc para proporcionar una lista de consumibles.",
        "equipment-name-label": "Nombre del equipo:",
        "quantity-label": "Cantidad:",
        "ring-bp-label": "Anillo/PV:",
        "location-override-label": "Sustitución de ubicación:",
        "task-override-label": "Sustitución de tarea:",
        "consumables-label": "Consumibles:",
        "effort-minutes-label": "Esfuerzo (minutos):",
        "description-label": "Descripción:",
        "issues-with-plan": "Hay uno o más problemas con su plan. Por favor, resuélvalos antes de continuar",
        "issues-with-import": "Puede que haya habido problemas con su importación",
        "unknown-error": "Error desconocido"
    },
    "week-side-drawer": {
        baselines: "Líneas base",
        "stop-showing-baseline": "Dejar de mostrar la línea base",
        "enable-historic-edit": "Habilitar edición histórica",
        "filters-and-groups": "Filtros y grupos",
        filters: "Filtros",
        grouping: "Agrupación",
        columns: "Columnas",
        groupings: "Agrupaciones",
        "allow-movement": "Permitir movimiento",
        "are-you-sure-move-historic-cycles": "¿Está seguro de que desea mover ciclos históricos? ¡Esto afectará los datos reales! Solo debe usar esto si un ciclo se movió erróneamente al pasado"
    },
    "auto-board-refresher": {
        "auto-refresh-mode": "Modo de actualización automática"
    },
    "resource-levelling-hint-menu": {
        "clear-override": "Borrar sustitución",
        "contributing-work": "Trabajo contribuyente",
        "under-resourced-title": "Con recursos insuficientes",
        "over-resource-target-title": "Por encima del objetivo de recursos",
        "under-utilised-title": "Subutilizado",
        "no-crew-title": "Sin personal de turno",
        "no-resources-title": "Sin recursos",
        "under-resourced-message-1": "No hay suficientes horas de esfuerzo disponibles en este turno.",
        "under-resourced-message-2": "Intente agregar al turno personal capaz de realizar este tipo de trabajo, o mover algunas tareas a otros turnos.",
        "over-resource-target-message-1": "Las horas de esfuerzo requeridas para este tipo de trabajo superan el objetivo porcentual de recursos.",
        "over-resource-target-message-2": "Si esto es un problema, intente agregar al turno personal capaz de realizar este tipo de trabajo, o mover algunas tareas a otros turnos.",
        "under-utilised-message-1": "Las horas de esfuerzo están por debajo del porcentaje de subutilización. Esto puede significar que tiene personal subutilizado.",
        "under-utilised-message-2": "Intente mover algunas tareas a este turno desde otros turnos.",
        "no-crew-message-1": "No hay personal de turno asignado a este turno.",
        "no-crew-message-2": "Para ver el estado de los recursos, asigne personal de turno al turno.",
        "no-resources-message-1": "No hay personal disponible en este turno capaz de realizar este tipo de trabajo.",
        "no-resources-message-2": "Agregue personal al turno, o elimine todas las tareas de este tipo del turno.",
        "acceptable-message": "Recursos aceptables.",
        "overridden-suffix": " (anulado)",
        "tooltip-no-crew": "Aún no hay personal asignado.",
        "tooltip-no-resources": "No hay recursos disponibles para este tipo de trabajo. Se requieren {requiredHours} horas.",
        "tooltip-over-resource-target": "Objetivo de recursos superado. {availableHours} horas{overridden} disponibles, {requiredHours} horas requeridas.",
        "tooltip-over-resource-availability": "Recursos insuficientes de este tipo disponibles. {availableHours} horas{overridden} disponibles, {requiredHours} horas requeridas.",
        "tooltip-under-utilised": "Los recursos están subutilizados. {availableHours} horas{overridden} disponibles, {requiredHours} horas requeridas.",
        "tooltip-acceptable": "Recursos aceptables. {availableHours} horas{overridden} disponibles, {requiredHours} horas requeridas."
    },
    "stope-tarp-statuses-list": {
        "last-updated": "Última actualización"
    },
    "production-front-visualisation": {
        "error-loading-overlay": "Error al cargar la superposición {overlay} para el nivel {level}",
        "front-band-path-start": "M {x1},{y1} L {x2},{y2}",
        "diagram-warnings": "Advertencias del diagrama"
    },
    "summary-tarp-status": {
        "change-status": "Cambiar estado",
        "view-history": "Ver historial"
    },
    "task-information": {
        "shift-plan": "Plan del turno",
        "remaining-actuals": "Valores reales restantes"
    },
    shift: {
        "show-inactive-term": "Mostrar {term} inactivos",
        "print-name": "Imprimir {name}",
        "configure-board": "Configurar tablero",
        "quick-actions": "Acciones rápidas",
        "frequently-taken-actions": "Acciones frecuentes",
        "full-activity-names-on-week-board": "Nombres completos de actividades en el tablero semanal",
        "collapse-grouped-adhoc-tasks-alt-y": "Contraer tareas ad hoc agrupadas (Alt+Y)",
        "saving-changes": "Guardando cambios…",
        language: "Idioma",
        "no-next-shift-planned": "No hay siguiente turno planificado",
        "24-hour-view": "Vista de 24 horas",
        "single-shift-view": "Vista de un solo turno",
        "generate-week-targets": "Generar objetivos de la semana",
        "manual-planning": "Planificación manual",
        "print-pack": "Imprimir paquete",
        "print-screen": "Imprimir pantalla",
        "screenshot-screen": "Captura de pantalla",
        "variance-report": "Informe de variación",
        "to-force-speed-dial-to-be-included": "Para forzar la inclusión del marcado rápido"
    },
    "equipment-in-location-card": {
        commentary: "Comentario",
        "mark-as-serviceable": "Marcar como utilizable",
        "mark-as-unserviceable": "Marcar como inservible",
        "mark-as-not-in-workshop-this-shift": "Marcar como no en taller este turno",
        "mark-as-in-workshop-this-shift": "Marcar como en taller este turno",
        "in-workshop": "En taller",
        "mark-as-not-needed-in-workshop-at-eos": "Marcar como no necesario en taller al fin de turno",
        "mark-as-needed-in-workshop-at-eos": "Marcar como necesario en taller al fin de turno",
        "needed-in-workshop": "Necesario en taller",
        "add-hazard": "Añadir peligro",
        "in-workshop-task": "EN TALLER",
        "tram-to-workshop": "TRASLADAR AL TALLER"
    },
    "department-selector": {
        "mine-interactions": "Interacciones de la mina",
        "mine-interactions-board": "Tablero de interacciones de la mina"
    },
    "to-do-action-dialog": {
        "completed-at": "Completado {time}",
        "started-at": "Iniciado {time}",
        "undo-completion": "Deshacer finalización",
        "mark-completed": "Marcar como completado",
        "add-comment": "Añadir comentario",
        "cannot-remove-comments-offline": "No se pueden eliminar comentarios sin conexión.",
        "remove-comment": "Eliminar comentario",
        "cannot-delete-tasks-offline": "No se pueden eliminar tareas sin conexión.",
        "delete-task": "Eliminar tarea",
        "cannot-edit-tasks-offline": "No se pueden editar tareas sin conexión.",
        "edit-task": "Editar tarea"
    },
    "location-tracker-image-menu": {
        "view-level-map": "Ver mapa del nivel"
    },
    "priority-analytics": {
        "analytics-date": "Análisis, {date}",
        "analytics-week": "Análisis Semana {weekNumber} - {weekOf}",
        "shift-planning-not-started-full": "La planificación de este turno no ha comenzado. Comience la planificación desde el tablero de turno",
        "week-planning-not-started-full": "La planificación de esta semana no ha comenzado. Cree un plan semanal antes de planificar este turno"
    },
    "location-task-card": {
        "activity-description": "Descripción de la actividad"
    },
    "location-survey-metric-details-dialog": {
        "remove-metric": "Eliminar {metricName}",
        "confirm-delete-metric": "¿Desea continuar y eliminar este {metricName}?",
        "cannot-delete-whilst-offline": "No se puede eliminar sin conexión.",
        "remove-chainage": "Eliminar cadenamiento",
        "no-historical-data-available": "No hay datos históricos disponibles.",
        "load-historical-data": "Cargar datos históricos",
        "this-action-could-affect-figures": "Esta acción podría afectar las cifras calculadas y los informes.",
        "this-action-will-be-audited": "Esta acción será auditada."
    },
    "shift-crew-selection-menu": {
        "assign-crews": "Asignar personal de turno"
    },
    logo: {
        "ordo-logo": "Logo de Ordo"
    },
    "standard-attachment-preview": {
        "upload-name": "Subir {name}",
        sending: "Enviando...",
        remove: "Eliminar",
        "open-for-printing": "Abrir para imprimir"
    },
    "shift-supervisor-page": {
        "staff-and-term": "Personal y {term}",
        "no-crew-selected": "No hay personal seleccionado",
        "safety-and-incidents": "Seguridad e incidentes",
        "abandon-changes-confirm": "Ha realizado cambios en las siguientes pestañas que se perderán si continúa sin guardarlos. ¿Descartar los cambios?"
    },
    "location-extended-properties": {
        "possible-values": "Valores posibles",
        "location-property": "Propiedad de la ubicación"
    },
    "equipment-card": {
        "mark-as-serviceable": "Marcar como utilizable",
        "mark-as-unserviceable": "Marcar como inservible",
        "mark-as-not-in-workshop-this-shift": "Marcar como no en taller este turno",
        "mark-as-in-workshop-this-shift": "Marcar como en taller este turno",
        "in-workshop": "En taller",
        "mark-as-not-needed-in-workshop-at-eos": "Marcar como no necesario en taller al fin de turno",
        "mark-as-needed-in-workshop-at-eos": "Marcar como necesario en taller al fin de turno",
        "needed-in-workshop": "Necesario en taller",
        "add-hazard": "Añadir peligro",
        "in-workshop-task": "EN TALLER",
        "tram-to-workshop": "TRASLADAR AL TALLER"
    },
    row: {
        "unknown-action": "Acción desconocida: {action}",
        "delete-name": "Eliminar {name}",
        "are-you-sure-delete-task": "¿Está seguro de que desea eliminar esta tarea?"
    },
    "set-location-chainage-dialog": {
        "active-from": "Activo desde",
        "update-chainage-title": "Actualizar cadenamiento - {name}",
    },
    "set-location-survey-metric-dialog": {
        "active-from": "Activo desde"
    },
    "in-place-numeric-editor": {
        confirm: "Confirmar"
    },
    "location-with-equipment-card": {
        "assign-to-equipment": "Asignar a {equipment}.",
        commentary: "Comentario",
        "add-hazard": "Añadir peligro",
        "no-term-to-assign-to": "No hay {term} a los que asignar.",
        "assign-to-all-term": "Asignar a todos los {term}",
        "multiple-term-allocated": "Múltiples {term} asignados. Asigne directamente a {term} en su lugar."
    },
    "column-filter-and-sort-menu": {
        "group-by": "Agrupar por {columnName}",
        "sort-and-filter": "Ordenar y filtrar",
        ungroup: "Desagrupar",
        "sort-ascending": "Orden ascendente",
        "sort-descending": "Orden descendente",
        clear: "Limpiar",
        okay: "Aceptar"
    },
    "operator-completion-sheet": {
        "filter-to-operator": "Filtrar por operador.",
        "manual-plods": "PLOD manuales"
    },
    "in-place-time-editor": {
        confirm: "Confirmar"
    },
    "reorder-rings-dialog": {
        "term-reorder-dialog": "Cuadro de diálogo de reordenamiento de {term}"
    },
    "ring-configurations": {
        "drill-length-avg": "Longitud de perforación (prom.)",
        "charge-amount-avg": "Cantidad de carga (prom.)"
    },
    "week-visualiser": {
        "collision-between": "Colisión entre {taskA} ({startA} - {endA}) y {taskB} ({startB} - {endB}) "
    },
    "reduced-levels": {
        "failed-to-upload-term-map": "Error al subir el mapa de {term}",
        "failed-to-remove-term-map": "Error al eliminar el mapa de {term}"
    },
    "location-ring-dialog": {
        "edit-term": "Editar {term}",
        "create-term": "Crear {term}",
        "update-term": "¿Actualizar {term}?",
        "ring-belongs-to-blast-packet": "Este {ring} pertenece a un {blastPacket}. ¿Desea actualizar también el {blastPacket}?"
    },
    confirm: {
        "delete-resource": "Eliminar {resourceType}",
        "confirm-delete-resource": "¿Está seguro de que desea eliminar este {resourceType}?"
    },
    "location-progress": {
        "total-pips-exceed-max": "El total de pips no debe exceder maxSegments."
    },
    "week-task-contents": {
        "cut-number-text": "Corte n.º {cutNumber} : {text}"
    },
    "data-table-priority-editor": {
        "update-name": "Actualizar {name}"
    },
    "data-table-property-editor": {
        "update-name": "Actualizar {name}"
    },
    "data-table-select-editor": {
        "update-text": "Actualizar {text}"
    }
};

export default es;
